import Util from "./util";

/**
 * 共通(観測所一覧)
 */
export default {
  getDispTowns,
  createDataPrefInfo,
  createDataRsysInfo,
  matchObsTmInfo,
  convertTmInfo,
  convertRpTmList,
  getIcon,
  setDispTwnTmInfo,
  setDispRvrTmInfo,
  setTmPointIndivParam,
  setTmSwPointIndivParam,
  setTmPointIndivData,
  setSwTmPointIndivData,
  setObsDate,
  setObsTime,
  convertIndivDataList,
  getStgOvlvlNm,
  getSwStgOvlvlNm,
  getShortStgOvlvlNm,
  getShortSwStgOvlvlNm,
  checkNotCollected,
};

// 未収集 : 内容コード
const NOT_COLLECTED = 160;

//------------------------------------------------------------
/**
 * [観測所一覧]表示対象市町村一覧抽出
 * @param {*} towns 表示市町村
 * @param {*} prefList  都道府県市町村別一覧
 */
function getDispTowns(towns, prefList) {
  var tmpList = [];

  for (var i in prefList) {
    tmpList = [];
    for (var j in prefList[i].twnInfo) {
      for (var k in towns) {
        if (prefList[i].twnInfo[j].twnCd == towns[k].id) {
          tmpList.push(prefList[i].twnInfo[j]);
        }
      }
    }
    prefList[i].twnInfo = tmpList;
  }
  return prefList;
}

/**
 * [観測所一覧]都道府県市町村データ成形
 * @param {*} prefList  都道府県市町村一覧
 * @param {*} selectObsDisp 観測所表示設定
 * @param {*} isPref 都道府県フラグ
 */
function createDataPrefInfo(prefList, selectObsDisp, isPref) {
  var rtList = [];
  var prefStgOvlvl = null;
  var prefSwStgOvlvl = null;

  // 表示する都道府県市町村リストを生成する
  for (var i in prefList) {
    var twns = [];
    prefStgOvlvl = null;
    prefSwStgOvlvl = null;

    for (var j in prefList[i].twnInfo) {
      // 観測所表示設定がONになっている観測所詳細フラグをチェック
      var existNm = checkExistFlg(prefList[i].twnInfo[j], selectObsDisp);
      if (!isPref) {
        // 市町村レベルの場合表示範囲中最大の超過値を算出する
        if (
          (prefList[i].twnInfo[j].stgOvlvl != null) &
          (prefStgOvlvl < prefList[i].twnInfo[j].stgOvlvl)
        ) {
          prefStgOvlvl = prefList[i].twnInfo[j].stgOvlvl;
        }
        if (
          (prefList[i].twnInfo[j].swStgOvlvl != null) &
          (prefSwStgOvlvl < prefList[i].twnInfo[j].swStgOvlvl)
        ) {
          prefSwStgOvlvl = prefList[i].twnInfo[j].swStgOvlvl;
        }
      }
      // 表示する観測所がある場合は観測所情報を追加
      if (existNm > 0) {
        // 市町村の超過レベルを取得する
        prefList[i].twnInfo[j].maxOvLvl = checOvLvlFlg(
          prefList[i].twnInfo[j].stgOvlvl,
          prefList[i].twnInfo[j].swStgOvlvl,
          selectObsDisp
        );
        prefList[i].twnInfo[j].showStg = checStgFlg(
          prefList[i].twnInfo[j].stgOvlvl,
          prefList[i].twnInfo[j].swStgOvlvl,
          selectObsDisp
        );
        twns.push(prefList[i].twnInfo[j]);
      }
    }
    if (!isEmpty(twns)) {
      prefList[i].twnInfo = twns;
      if (isPref) {
        // 都道府県レベルの場合
        prefStgOvlvl = prefList[i].stgOvlvl;
        prefSwStgOvlvl = prefList[i].swStgOvlvl;
      }
      // 都道府県の超過レベルを取得する
      prefList[i].maxOvLvl = checOvLvlFlg(
        prefStgOvlvl,
        prefSwStgOvlvl,
        selectObsDisp
      );
      prefList[i].showStg = checStgFlg(
        prefStgOvlvl,
        prefSwStgOvlvl,
        selectObsDisp
      );
    } else {
      // 市町村が空の場合削除
      delete prefList[i];
    }
  }

  // 市町村情報が存在する都道府県市町村リストを作成
  for (var k in prefList) {
    if (!isEmpty(prefList[k])) {
      rtList.push(prefList[k]);
    }
  }
  return rtList;
}

/**
 * [観測所一覧]水系河川データ成形
 * @param {*} rsysList  水系河川別一覧
 * @param {*} selectObsDisp 観測所表示設定
 * @param {*} isPref 都道府県フラグ
 */
function createDataRsysInfo(rsysList, selectObsDisp, isPref) {
  var rtList = [];
  var rsysStgOvlvl = null;
  var rsysSwStgOvlvl = null;

  // 表示する水系河川リストを生成する
  for (var o in rsysList) {
    var dispRvrs = [];
    rsysStgOvlvl = null;
    rsysSwStgOvlvl = null;
    for (var p in rsysList[o].rvrInfo) {
      // 観測所表示設定がONになっている観測所詳細フラグをチェック
      var existDispNm = checkExistFlg(rsysList[o].rvrInfo[p], selectObsDisp);
      if (!isPref) {
        // 市町村レベルの場合表示範囲中最大の超過値を算出する
        if (
          (rsysList[o].rvrInfo[p].stgOvlvl != null) &
          (rsysStgOvlvl < rsysList[o].rvrInfo[p].stgOvlvl)
        ) {
          rsysStgOvlvl = rsysList[o].rvrInfo[p].stgOvlvl;
        }
        if (
          (rsysList[o].rvrInfo[p].swStgOvlvl != null) &
          (rsysSwStgOvlvl < rsysList[o].rvrInfo[p].swStgOvlvl)
        ) {
          rsysSwStgOvlvl = rsysList[o].rvrInfo[p].swStgOvlvl;
        }
      }
      // 表示する観測所がある場合は観測所情報を追加
      if (existDispNm > 0) {
        // 河川の超過レベルを取得する
        rsysList[o].rvrInfo[p].maxOvLvl = checOvLvlFlg(
          rsysList[o].rvrInfo[p].stgOvlvl,
          rsysList[o].rvrInfo[p].swStgOvlvl,
          selectObsDisp
        );
        rsysList[o].rvrInfo[p].showStg = checStgFlg(
          rsysList[o].rvrInfo[p].stgOvlvl,
          rsysList[o].rvrInfo[p].swStgOvlvl,
          selectObsDisp
        );
        dispRvrs.push(rsysList[o].rvrInfo[p]);
      }
    }
    if (!isEmpty(dispRvrs)) {
      rsysList[o].rvrInfo = dispRvrs;
      if (isPref) {
        // 都道府県レベルの場合
        rsysStgOvlvl = rsysList[o].stgOvlvl;
        rsysSwStgOvlvl = rsysList[o].swStgOvlvl;
      }
      // 水系の超過レベルを取得する
      rsysList[o].maxOvLvl = checOvLvlFlg(
        rsysStgOvlvl,
        rsysSwStgOvlvl,
        selectObsDisp
      );
      rsysList[o].showStg = checStgFlg(
        rsysStgOvlvl,
        rsysSwStgOvlvl,
        selectObsDisp
      );
    } else {
      // 河川が空の場合削除
      delete rsysList[o];
    }
  }
  // 水系河川情報が存在する水系河川リストを作成
  for (var q in rsysList) {
    if (!isEmpty(rsysList[q])) {
      rtList.push(rsysList[q]);
    }
  }
  return rtList;
}

/**
 * [観測所一覧]観測所情報と観測値情報を合致させる
 * @param {*} ObsInfo  市町村別観測所一覧
 * @param {*} TmInfo 市町村別観測値一覧
 * @param {string} appTime 表示時刻
 * @param {number} edtCmn 最新値ファイル用欠測判定時間
 */
function matchObsTmInfo(ObsInfo, TmInfo, appTime, edtCmn) {
  if (process.env.NODE_ENV === "development") {
    // ローカルで動作させる場合は欠測判定をしない。
    // 表示時刻を上書きするため、観測所情報と一致する観測値情報無い場合、画面上でも下記の時刻で出力される
    appTime = "2020/01/01 00:00";
  }
  // 10分単位で末尾を丸める
  let targetTime = Util.formatDate(appTime);
  targetTime =
    Util.formatDate(targetTime).substring(0, targetTime.length - 1) + "0";

  // 10分単位の表示時刻から欠測判定時間前の時間を取得する
  let JudgeTime = Util.formatDate(Util.subMinutes(targetTime, edtCmn));
  // 観測値追加フラグ
  let addTmFlg = false;

  // 通常水位
  for (var obsStg of ObsInfo.obsStg) {
    addTmFlg = false;
    if (TmInfo) {
      for (var tmStg of TmInfo.tmStg) {
        if (obsStg.obsFcd === tmStg.obsFcd) {
          // 欠測判定時間よりも最新の場合追加
          if (JudgeTime < tmStg.obsTime) {
            obsStg.obsTime = tmStg.obsTime;
            obsStg.stg = tmStg.stg;
            obsStg.stgHght = tmStg.stgHght;
            obsStg.stgCcd = tmStg.stgCcd;
            obsStg.stgLtstChg = tmStg.stgLtstChg;
            obsStg.stg10mChg = tmStg.stg10mChg;
            obsStg.stg10mChgCcd = tmStg.stg10mChgCcd;
            obsStg.stgOvlvl = tmStg.stgOvlvl;
            obsStg.stgQmflg = tmStg.stgQmflg;
            addTmFlg = true;
          }
          // 一致データがあったら次のループへ進む
          break;
        }
      }
    }
    if (!TmInfo || !addTmFlg) {
      // 観測値情報が無い場合、もしくは観測所情報と一致する観測値情報が無い場合未収集
      obsStg.obsTime = Util.formatDate(appTime, "YYYY/MM/DD HH:mm");
      obsStg.stg = null;
      obsStg.stgHght = null;
      obsStg.stgCcd = NOT_COLLECTED;
      obsStg.stgLtstChg = null;
      obsStg.stg10mChg = null;
      obsStg.stg10mChgCcd = NOT_COLLECTED;
      obsStg.stgOvlvl = null;
      obsStg.stgQmflg = null;
    }
  }

  // ダム諸量
  for (var obsDam of ObsInfo.obsDam) {
    addTmFlg = false;
    if (TmInfo) {
      for (var tmDam of TmInfo.tmDam) {
        if (obsDam.obsFcd === tmDam.obsFcd) {
          if (JudgeTime < tmDam.obsTime) {
            // 欠測判定時間よりも最新の場合追加
            obsDam.obsTime = tmDam.obsTime;
            obsDam.storLvl = tmDam.storLvl;
            obsDam.storLvlCcd = tmDam.storLvlCcd;
            obsDam.storCap = tmDam.storCap;
            obsDam.storCapCcd = tmDam.storCapCcd;
            obsDam.storFcntIrr = tmDam.storFcntIrr;
            obsDam.storFcntIrrCcd = tmDam.storFcntIrrCcd;
            obsDam.storPcntIrr = tmDam.storPcntIrr;
            obsDam.storPcntIrrCcd = tmDam.storPcntIrrCcd;
            obsDam.storPcntEff = tmDam.storPcntEff;
            obsDam.storPcntEffCcd = tmDam.storPcntEffCcd;
            obsDam.allSink = tmDam.allSink;
            obsDam.allSinkCcd = tmDam.allSinkCcd;
            obsDam.allDisch = tmDam.allDisch;
            obsDam.allDischCcd = tmDam.allDischCcd;
            obsDam.bsnrnHr10m = tmDam.bsnrnHr10m;
            obsDam.bsnrnHr10mCcd = tmDam.bsnrnHr10mCcd;
            obsDam.bsnrnInc = tmDam.bsnrnInc;
            obsDam.bsnrnIncCcd = tmDam.bsnrnIncCcd;
            obsDam.rdbsnrnHr10m = tmDam.rdbsnrnHr10m;
            obsDam.rdbsnrnHr10mCcd = tmDam.rdbsnrnHr10mCcd;
            obsDam.rdbsnrnInc = tmDam.rdbsnrnInc;
            obsDam.rdbsnrnIncCcd = tmDam.rdbsnrnIncCcd;
            obsDam.damdschLvl = tmDam.damdschLvl;
            addTmFlg = true;
          }
          // 一致データがあったら次のループへ進む
          break;
        }
      }
    }

    if (!TmInfo || !addTmFlg) {
      // 観測値情報が無い場合、もしくは観測所情報と一致する観測値情報が無い場合未収集
      obsDam.obsTime = Util.formatDate(appTime, "YYYY/MM/DD HH:mm");
      obsDam.storLvl = null;
      obsDam.storLvlCcd = NOT_COLLECTED;
      obsDam.storCap = null;
      obsDam.storCapCcd = NOT_COLLECTED;
      obsDam.storFcntIrr = null;
      obsDam.storFcntIrrCcd = NOT_COLLECTED;
      obsDam.storPcntIrr = null;
      obsDam.storPcntIrrCcd = NOT_COLLECTED;
      obsDam.storPcntEff = null;
      obsDam.storPcntEffCcd = NOT_COLLECTED;
      obsDam.allSink = null;
      obsDam.allSinkCcd = NOT_COLLECTED;
      obsDam.allDisch = null;
      obsDam.allDischCcd = NOT_COLLECTED;
      obsDam.bsnrnHr10m = null;
      obsDam.bsnrnHr10mCcd = NOT_COLLECTED;
      obsDam.bsnrnInc = null;
      obsDam.bsnrnIncCcd = NOT_COLLECTED;
      obsDam.rdbsnrnHr10m = null;
      obsDam.rdbsnrnHr10mCcd = NOT_COLLECTED;
      obsDam.rdbsnrnInc = null;
      obsDam.rdbsnrnIncCcd = NOT_COLLECTED;
      obsDam.damdschLvl = null;
    }
  }

  // 雨量
  for (var obsRn of ObsInfo.obsRn) {
    addTmFlg = false;
    if (TmInfo) {
      for (var tmRn of TmInfo.tmRn) {
        if (obsRn.obsFcd === tmRn.obsFcd) {
          if (JudgeTime < tmRn.obsTime) {
            // 欠測判定時間よりも最新の場合追加
            obsRn.obsTime = tmRn.obsTime;
            obsRn.rn10m = tmRn.rn10m;
            obsRn.rn10mCcd = tmRn.rn10mCcd;
            obsRn.rnInc = tmRn.rnInc;
            obsRn.rnIncCcd = tmRn.rnIncCcd;
            obsRn.rn60m = tmRn.rn60m;
            obsRn.rn60mCcd = tmRn.rn60mCcd;
            obsRn.rnHr10m = tmRn.rnHr10m;
            obsRn.rnHr10mCcd = tmRn.rnHr10mCcd;
            addTmFlg = true;
          }
          // 一致データがあったら次のループへ進む
          break;
        }
      }
    }

    if (!TmInfo || !addTmFlg) {
      // 観測値情報が無い場合、もしくは観測所情報と一致する観測値情報が無い場合未収集
      obsRn.obsTime = Util.formatDate(appTime, "YYYY/MM/DD HH:mm");
      obsRn.rn10m = null;
      obsRn.rn10mCcd = NOT_COLLECTED;
      obsRn.rnInc = null;
      obsRn.rnIncCcd = NOT_COLLECTED;
      obsRn.rn60m = null;
      obsRn.rn60mCcd = NOT_COLLECTED;
      obsRn.rnHr10m = null;
      obsRn.rnHr10mCcd = NOT_COLLECTED;
    }
  }

  // 積雪深
  for (var obsSnow of ObsInfo.obsSnow) {
    addTmFlg = false;
    if (TmInfo) {
      for (var tmSnow of TmInfo.tmSnow) {
        if (obsSnow.obsFcd === tmSnow.obsFcd) {
          if (JudgeTime < tmSnow.obsTime) {
            // 欠測判定時間よりも最新の場合追加
            obsSnow.obsTime = tmSnow.obsTime;
            obsSnow.snwdp = tmSnow.snwdp;
            obsSnow.snwdpCcd = tmSnow.snwdpCcd;
            obsSnow.tmp = tmSnow.tmp;
            obsSnow.tmpCcd = tmSnow.tmpCcd;
            addTmFlg = true;
          }
          // 一致データがあったら次のループへ進む
          break;
        }
      }
    }
    if (!TmInfo || !addTmFlg) {
      // 観測値情報が無い場合、もしくは観測所情報と一致する観測値情報が無い場合未収集
      obsSnow.obsTime = Util.formatDate(appTime, "YYYY/MM/DD HH:mm");
      obsSnow.snwdp = null;
      obsSnow.snwdpCcd = NOT_COLLECTED;
      obsSnow.tmp = null;
      obsSnow.tmpCcd = NOT_COLLECTED;
    }
  }

  // 海岸
  for (var obsCoast of ObsInfo.obsCoast) {
    addTmFlg = false;
    if (TmInfo) {
      for (var tmCoast of TmInfo.tmCoast) {
        if (obsCoast.obsFcd === tmCoast.obsFcd) {
          if (JudgeTime < tmCoast.obsTime) {
            // 欠測判定時間よりも最新の場合追加
            obsCoast.obsTime = tmCoast.obsTime;
            obsCoast.maxwvHght = tmCoast.maxwvHght;
            obsCoast.maxwvHghtCcd = tmCoast.maxwvHghtCcd;
            obsCoast.maxwvCycl = tmCoast.maxwvCycl;
            obsCoast.maxwvCyclCcd = tmCoast.maxwvCyclCcd;
            obsCoast.onthwvHght = tmCoast.onthwvHght;
            obsCoast.onthwvHghtCcd = tmCoast.onthwvHghtCcd;
            obsCoast.onthwvHghtWarnOvflg = tmCoast.onthwvHghtWarnOvflg;
            obsCoast.onthwvHghtCautOvflg = tmCoast.onthwvHghtCautOvflg;
            obsCoast.onthwvCycl = tmCoast.onthwvCycl;
            obsCoast.onthwvCyclCcd = tmCoast.onthwvCyclCcd;
            obsCoast.tidlvl = tmCoast.tidlvl;
            obsCoast.tidlvlCcd = tmCoast.tidlvlCcd;
            obsCoast.tidlvlWarnOvflg = tmCoast.tidlvlWarnOvflg;
            obsCoast.tidlvlCautOvflg = tmCoast.tidlvlCautOvflg;
            obsCoast.avewndSpd = tmCoast.avewndSpd;
            obsCoast.avewndSpdCcd = tmCoast.avewndSpdCcd;
            obsCoast.avewndSpdWarnOvflg = tmCoast.avewndSpdWarnOvflg;
            obsCoast.avewndSpdCautOvflg = tmCoast.avewndSpdCautOvflg;
            obsCoast.avewndDir = tmCoast.avewndDir;
            obsCoast.avewndDirCcd = tmCoast.avewndDirCcd;
            addTmFlg = true;
          }
          // 一致データがあったら次のループへ進む
          break;
        }
      }
    }

    if (!TmInfo || !addTmFlg) {
      // 観測値情報が無い場合、もしくは観測所情報と一致する観測値情報が無い場合未収集
      obsCoast.obsTime = Util.formatDate(appTime, "YYYY/MM/DD HH:mm");
      obsCoast.maxwvHght = null;
      obsCoast.maxwvHghtCcd = NOT_COLLECTED;
      obsCoast.maxwvCycl = null;
      obsCoast.maxwvCyclCcd = NOT_COLLECTED;
      obsCoast.onthwvHght = null;
      obsCoast.onthwvHghtCcd = NOT_COLLECTED;
      obsCoast.onthwvHghtWarnOvflg = null;
      obsCoast.onthwvHghtCautOvflg = null;
      obsCoast.onthwvCycl = null;
      obsCoast.onthwvCyclCcd = NOT_COLLECTED;
      obsCoast.tidlvl = null;
      obsCoast.tidlvlCcd = NOT_COLLECTED;
      obsCoast.tidlvlWarnOvflg = null;
      obsCoast.tidlvlCautOvflg = null;
      obsCoast.avewndSpd = null;
      obsCoast.avewndSpdCcd = NOT_COLLECTED;
      obsCoast.avewndSpdWarnOvflg = null;
      obsCoast.avewndSpdCautOvflg = null;
      obsCoast.avewndDir = null;
      obsCoast.avewndDirCcd = NOT_COLLECTED;
    }
  }

  // 水質
  for (var obsQwtr of ObsInfo.obsQwtr) {
    addTmFlg = false;
    if (TmInfo) {
      for (var tmQwtr of TmInfo.tmQwtr) {
        if (obsQwtr.obsFcd === tmQwtr.obsFcd) {
          if (JudgeTime < tmQwtr.obsTime) {
            // 欠測判定時間よりも最新の場合追加
            obsQwtr.obsTime = tmQwtr.obsTime;
            obsQwtr.wtrtmp = tmQwtr.wtrtmp;
            obsQwtr.wtrtmpCcd = tmQwtr.wtrtmpCcd;
            obsQwtr.wtrtmpOvcd = tmQwtr.wtrtmpOvcd;
            obsQwtr.conduct = tmQwtr.conduct;
            obsQwtr.conductCcd = tmQwtr.conductCcd;
            obsQwtr.conductOvcd = tmQwtr.conductOvcd;
            obsQwtr.dox = tmQwtr.dox;
            obsQwtr.doxCcd = tmQwtr.doxCcd;
            obsQwtr.doxOvcd = tmQwtr.doxOvcd;
            obsQwtr.ph = tmQwtr.ph;
            obsQwtr.phCcd = tmQwtr.phCcd;
            obsQwtr.phOvcd = tmQwtr.phOvcd;
            obsQwtr.turbdty = tmQwtr.turbdty;
            obsQwtr.turbdtyCcd = tmQwtr.turbdtyCcd;
            obsQwtr.turbdtyOvcd = tmQwtr.turbdtyOvcd;
            obsQwtr.cod = tmQwtr.cod;
            obsQwtr.codCcd = tmQwtr.codCcd;
            obsQwtr.codOvcd = tmQwtr.codOvcd;
            obsQwtr.amn = tmQwtr.amn;
            obsQwtr.amnCcd = tmQwtr.amnCcd;
            obsQwtr.amnOvcd = tmQwtr.amnOvcd;
            obsQwtr.slt = tmQwtr.slt;
            obsQwtr.sltCcd = tmQwtr.sltCcd;
            obsQwtr.sltOvcd = tmQwtr.sltOvcd;
            addTmFlg = true;
          }

          // 一致データがあったら次のループへ進む
          break;
        }
      }
    }
    if (!TmInfo || !addTmFlg) {
      // 観測値情報が無い場合、もしくは観測所情報と一致する観測値情報が無い場合未収集
      obsQwtr.obsTime = Util.formatDate(appTime, "YYYY/MM/DD HH:mm");
      obsQwtr.wtrtmp = null;
      obsQwtr.wtrtmpCcd = NOT_COLLECTED;
      obsQwtr.wtrtmpOvcd = null;
      obsQwtr.conduct = null;
      obsQwtr.conductCcd = NOT_COLLECTED;
      obsQwtr.conductOvcd = null;
      obsQwtr.dox = null;
      obsQwtr.doxCcd = NOT_COLLECTED;
      obsQwtr.doxOvcd = null;
      obsQwtr.ph = null;
      obsQwtr.phCcd = NOT_COLLECTED;
      obsQwtr.phOvcd = null;
      obsQwtr.turbdty = null;
      obsQwtr.turbdtyCcd = NOT_COLLECTED;
      obsQwtr.turbdtyOvcd = null;
      obsQwtr.cod = null;
      obsQwtr.codCcd = NOT_COLLECTED;
      obsQwtr.codOvcd = null;
      obsQwtr.amn = null;
      obsQwtr.amnCcd = NOT_COLLECTED;
      obsQwtr.amnOvcd = null;
      obsQwtr.slt = null;
      obsQwtr.sltCcd = NOT_COLLECTED;
      obsQwtr.sltOvcd = null;
    }
  }

  // 危機管理水位
  for (var obsSwin of ObsInfo.obsSwin) {
    addTmFlg = false;
    if (TmInfo) {
      for (var tmSwin of TmInfo.tmSwin) {
        if (obsSwin.swobsCd === tmSwin.swobsCd) {
          obsSwin.obsTime = tmSwin.obsTime;
          obsSwin.stgHght = tmSwin.stgHght;
          obsSwin.stgQmflg = tmSwin.stgQmflg;
          obsSwin.swstgOvlvl = tmSwin.swstgOvlvl;
          obsSwin.errCd = tmSwin.errCd;
          // 内容コードを設定する
          obsSwin.swstgCcd = 0;
          addTmFlg = true;

          // 一致データがあったら次のループへ進む
          break;
        }
      }
    }
    if (!TmInfo || !addTmFlg) {
      // 観測値情報が無い場合、もしくは観測所情報と一致する観測値情報が無い場合未収集
      obsSwin.obsTime = Util.formatDate(appTime, "YYYY/MM/DD HH:mm");
      obsSwin.stgHght = null;
      obsSwin.stgQmflg = null;
      obsSwin.swstgOvlvl = null;
      obsSwin.errCd = null;
      // 内容コードを設定する
      obsSwin.swstgCcd = NOT_COLLECTED;
    }
  }

  return ObsInfo;
}

/**
 * [観測所一覧]表示データ作成
 * @param {*} obsData 観測所情報
 * @param {*} stgMsg 水位表示切替メッセージ設定
 * @param {*} refObs 基準水位観測所メッセージ設定
 */
function convertTmInfo(obsData, stgMsg, refObs) {
  return {
    Stg: createJsonDataStgInfo(obsData.obsStg, stgMsg, refObs),
    Dam: createJsonDataDamInfo(obsData.obsDam),
    Rain: createJsonDataRainInfo(obsData.obsRn),
    Snow: createJsonDataSnowInfo(obsData.obsSnow),
    Cctv: createJsonDataCctvInfo(obsData.cctv),
    Scam: createJsonDataScamInfo(obsData.scam),
    Qwtr: createJsonDataQwtrInfo(obsData.obsQwtr),
    Coast: createJsonDataCoastInfo(obsData.obsCoast),
    Swin: createJsonDataSwstgInfo(obsData.obsSwin),
  };
}

/**
 * [通常水位]観測所情報
 * @param {*} obsData 通常水位観測所情報
 * @param {*} stgMsg 水位表示切替メッセージ設定
 * @param {*} refObs 基準水位観測所メッセージ設定
 */
function createJsonDataStgInfo(obsData, stgMsg, refObs) {
  // 通常表示用格納用リスト
  let nmList = [];
  // 拡大表示用格納用リスト
  let lgList = [];

  for (var stgCnt in obsData) {
    // 通常表示
    let nmItem = {
      ofcCd: obsData[stgCnt].ofcCd,
      obsCd: obsData[stgCnt].obsCd,
      obsNm: [
        obsData[stgCnt].obsNm,
        obsData[stgCnt].obsNm + refObs.referenceObs,
      ],
      dspFlg: obsData[stgCnt].dspFlg,
      obsTime: obsData[stgCnt].obsTime,
      items: [
        {
          // 零点高から
          desc: stgMsg.normalStgHght,
          val:
            typeof obsData[stgCnt].stg !== "undefined"
              ? Util.formatFloat(obsData[stgCnt].stg, 2)
              : null,
          unit: "m",
          qmFlg: obsData[stgCnt].stgQmflg,
        },
        {
          // 堤防天端から
          desc: stgMsg.topendStgHght,
          val:
            typeof obsData[stgCnt].stgHght !== "undefined"
              ? Util.formatFloat(obsData[stgCnt].stgHght, 2)
              : null,
          unit: "m",
          qmFlg: obsData[stgCnt].stgQmflg,
        },
      ],
      stgLtstChg: obsData[stgCnt].stgLtstChg,
      stg10mChg: obsData[stgCnt].stg10mChg,
      stg10mChgCcd: obsData[stgCnt].stg10mChgCcd,
      stgOvlvl: obsData[stgCnt].stgOvlvl,
      stgCcd: obsData[stgCnt].stgCcd,
      rsrvStg: obsData[stgCnt].rsrvStg,
      warnStg: obsData[stgCnt].warnStg,
      spclWarnStg: obsData[stgCnt].spclWarnStg,
      dngStg: obsData[stgCnt].dngStg,
      fldStg: obsData[stgCnt].fldStg,
      fldfrFlg: obsData[stgCnt].fldfrFlg,
      evstgFlg: obsData[stgCnt].evstgFlg,
      fldctlFlg: obsData[stgCnt].fldctlFlg,
    };
    nmList.push(nmItem);
    // 拡大表示
    let lgItem = {
      ofcCd: obsData[stgCnt].ofcCd,
      obsCd: obsData[stgCnt].obsCd,
      obsNm: [
        obsData[stgCnt].obsNm,
        obsData[stgCnt].obsNm + refObs.referenceObs,
      ],
      dspFlg: obsData[stgCnt].dspFlg,
      obsTime: obsData[stgCnt].obsTime,
      items: [
        {
          // 零点高から
          desc: stgMsg.normalStgHght,
          val:
            typeof obsData[stgCnt].stg !== "undefined"
              ? Util.formatFloat(obsData[stgCnt].stg, 2)
              : null,
          unit: "m",
          qmFlg: obsData[stgCnt].stgQmflg,
        },
        {
          // 堤防天端から
          desc: stgMsg.topendStgHght,
          val:
            typeof obsData[stgCnt].stgHght !== "undefined"
              ? Util.formatFloat(obsData[stgCnt].stgHght, 2)
              : null,
          unit: "m",
          qmFlg: obsData[stgCnt].stgQmflg,
        },
      ],
      stgLtstChg: obsData[stgCnt].stgLtstChg,
      stg10mChg: obsData[stgCnt].stg10mChg,
      stg10mChgCcd: obsData[stgCnt].stg10mChgCcd,
      stgOvlvl: obsData[stgCnt].stgOvlvl,
      stgCcd: obsData[stgCnt].stgCcd,
      rsrvStg: obsData[stgCnt].rsrvStg,
      warnStg: obsData[stgCnt].warnStg,
      spclWarnStg: obsData[stgCnt].spclWarnStg,
      dngStg: obsData[stgCnt].dngStg,
      fldStg: obsData[stgCnt].fldStg,
      fldfrFlg: obsData[stgCnt].fldfrFlg,
      evstgFlg: obsData[stgCnt].evstgFlg,
      fldctlFlg: obsData[stgCnt].fldctlFlg,
    };
    lgList.push(lgItem);
  }

  return {
    nmList: nmList,
    lgList: lgList,
  };
}

/**
 * [ダム諸量]観測所情報
 * @param {*} obsData ダム諸量観測所情報
 */
function createJsonDataDamInfo(obsData) {
  // 通常表示用格納用リスト
  let nmList = [];
  // 拡大表示用格納用リスト
  let lgList = [];

  for (var damCnt in obsData) {
    // 通常表示
    let nmItem = {
      ofcCd: obsData[damCnt].ofcCd,
      obsCd: obsData[damCnt].obsCd,
      obsNm: obsData[damCnt].obsNm,
      obsTime: obsData[damCnt].obsTime,
      items: [
        {
          desc: "貯水位",
          val:
            typeof obsData[damCnt].storLvl !== "undefined"
              ? Util.formatFloat(obsData[damCnt].storLvl, 2)
              : null,
          unit: "m",
          ccd: obsData[damCnt].storLvlCcd,
        },
        {
          desc: "貯水率有効容量",
          val: Util.formatFloat(obsData[damCnt].storPcntEff, 1),
          unit: "%",
          ccd: obsData[damCnt].storPcntEffCcd,
        },
      ],
      damdschLvl: obsData[damCnt].damdschLvl,
      storLvlCcd: obsData[damCnt].storLvlCcd,
      storCapCcd: obsData[damCnt].storCapCcd,
      storPcntIrrCcd: obsData[damCnt].storPcntIrrCcd,
      allSinkCcd: obsData[damCnt].allSinkCcd,
      allDischCcd: obsData[damCnt].allDischCcd,
      storPcntEffCcd: obsData[damCnt].storPcntEffCcd,
      rwNoticeMng: obsData[damCnt].rwNoticeMng,
    };
    nmList.push(nmItem);

    // 拡大表示
    let lgItem = getRelatLgList(obsData[damCnt]);
    lgList.push(lgItem);
  }

  return {
    nmList: nmList,
    lgList: lgList,
  };
}

/**
 * [CCTVカメラ]観測所情報
 * @param {*} obsData 河川カメラ観測所情報
 */
function createJsonDataCctvInfo(obsData) {
  // 通常表示用格納用リスト
  let nmList = [];
  // 拡大表示用格納用リスト
  let lgList = [];

  for (var cctvCnt in obsData) {
    // 通常表示
    let nmItem = {
      ofcCd: obsData[cctvCnt].ofcCd,
      cctvNm: obsData[cctvCnt].name,
      scamId: obsData[cctvCnt].scamId,
      ownCd: obsData[cctvCnt].ownCd,
      sysCamId: obsData[cctvCnt].sysCamId,
      items: [],
    };
    nmList.push(nmItem);

    // 拡大表示
    let lgItem = {
      ofcCd: obsData[cctvCnt].ofcCd,
      cctvNm: obsData[cctvCnt].name,
      scamId: obsData[cctvCnt].scamId,
      ownCd: obsData[cctvCnt].ownCd,
      sysCamId: obsData[cctvCnt].sysCamId,
      items: [],
    };
    lgList.push(lgItem);
  }
  return {
    nmList: nmList,
    lgList: lgList,
  };
}

/**
 * [簡易カメラ]観測所情報
 * @param {*} obsData 簡易カメラ観測所情報
 */
function createJsonDataScamInfo(obsData) {
  // 通常表示用格納用リスト
  let nmList = [];
  // 拡大表示用格納用リスト
  let lgList = [];

  for (var scamCnt in obsData) {
    // 通常表示
    let nmItem = {
      ofcCd: obsData[scamCnt].ofcCd,
      scamNm: obsData[scamCnt].name,
      scamId: obsData[scamCnt].scamId,
      ownCd: obsData[scamCnt].ownCd,
      sysCamId: obsData[scamCnt].sysCamId,
      items: [],
    };
    nmList.push(nmItem);

    // 拡大表示
    let lgItem = {
      ofcCd: obsData[scamCnt].ofcCd,
      scamNm: obsData[scamCnt].name,
      scamId: obsData[scamCnt].scamId,
      ownCd: obsData[scamCnt].ownCd,
      sysCamId: obsData[scamCnt].sysCamId,
      items: [],
    };
    lgList.push(lgItem);
  }
  return {
    nmList: nmList,
    lgList: lgList,
  };
}

/**
 * [雨量]観測所情報
 * @param {*} obsData 雨量観測所情報
 */
function createJsonDataRainInfo(obsData) {
  // 通常表示用格納用リスト
  let nmList = [];
  // 拡大表示用格納用リスト
  let lgList = [];

  for (var rnCnt in obsData) {
    // 通常表示
    let nmItem = {
      ofcCd: obsData[rnCnt].ofcCd,
      obsCd: obsData[rnCnt].obsCd,
      obsNm: obsData[rnCnt].obsNm,
      obsTime: obsData[rnCnt].obsTime,
      items: [
        {
          desc: "10分雨量",
          val:
            typeof obsData[rnCnt].rn10m !== "undefined"
              ? Util.formatFloat(obsData[rnCnt].rn10m, 1)
              : null,
          unit: "mm",
          ccd: obsData[rnCnt].rn10mCcd,
        },
        {
          desc: "累加雨量",
          val:
            typeof obsData[rnCnt].rnInc !== "undefined"
              ? Util.formatFloat(obsData[rnCnt].rnInc, 1)
              : null,
          unit: "mm",
          ccd: obsData[rnCnt].rnIncCcd,
        },
      ],
      rn10mCcd: obsData[rnCnt].rn10mCcd,
      rnHr10mCcd: obsData[rnCnt].rnHr10mCcd,
      rnIncCcd: obsData[rnCnt].rnIncCcd,
      rn60mCcd: obsData[rnCnt].rn60mCcd,
    };
    nmList.push(nmItem);

    // 拡大表示
    let lgItem = {
      ofcCd: obsData[rnCnt].ofcCd,
      obsCd: obsData[rnCnt].obsCd,
      obsNm: obsData[rnCnt].obsNm,
      obsTime: obsData[rnCnt].obsTime,
      items: [
        {
          desc: "10分雨量",
          val:
            typeof obsData[rnCnt].rn10m !== "undefined"
              ? Util.formatFloat(obsData[rnCnt].rn10m, 1)
              : null,
          unit: "mm",
          ccd: obsData[rnCnt].rn10mCcd,
        },
        {
          desc: "時間雨量",
          val:
            typeof obsData[rnCnt].rnHr10m !== "undefined"
              ? Util.formatFloat(obsData[rnCnt].rnHr10m, 1)
              : null,
          unit: "mm",
          ccd: obsData[rnCnt].rnHr10mCcd,
        },
        {
          desc: "累加雨量",
          val:
            typeof obsData[rnCnt].rnInc !== "undefined"
              ? Util.formatFloat(obsData[rnCnt].rnInc, 1)
              : null,
          unit: "mm",
          ccd: obsData[rnCnt].rnIncCcd,
        },
        // 要素数調整
        {
          desc: "",
          val: "",
          unit: "",
          ccd: null,
        },
        {
          desc: "",
          val: "",
          unit: "",
          ccd: null,
        },
        {
          desc: "",
          val: "",
          unit: "",
          ccd: null,
        },
      ],
      rn10mCcd: obsData[rnCnt].rn10mCcd,
      rnHr10mCcd: obsData[rnCnt].rnHr10mCcd,
      rnIncCcd: obsData[rnCnt].rnIncCcd,
      rn60mCcd: obsData[rnCnt].rn60mCcd,
    };
    lgList.push(lgItem);
  }

  return {
    nmList: nmList,
    lgList: lgList,
  };
}

/**
 * [水質]観測所情報
 * @param {*} obsData 水質観測所情報
 */
function createJsonDataQwtrInfo(obsData) {
  // 通常表示用格納用リスト
  let nmList = [];
  // 拡大表示用格納用リスト
  let lgList = [];

  for (var qwCnt in obsData) {
    // 通常表示
    let nmItem = {
      ofcCd: obsData[qwCnt].ofcCd,
      obsCd: obsData[qwCnt].obsCd,
      obsNm: obsData[qwCnt].obsNm,
      obsTime: obsData[qwCnt].obsTime,
      items: [
        {
          desc: "水温",
          val:
            typeof obsData[qwCnt].wtrtmp !== "undefined"
              ? Util.formatFloat(obsData[qwCnt].wtrtmp, 1)
              : null,
          unit: "℃",
          ccd: obsData[qwCnt].wtrtmpCcd,
        },
        {
          desc: "濁度",
          val:
            typeof obsData[qwCnt].turbdty !== "undefined"
              ? Util.formatFloat(obsData[qwCnt].turbdty, 1)
              : null,
          unit: "度",
          ccd: obsData[qwCnt].turbdtyCcd,
        },
      ],
      wtrtmpOvcd: obsData[qwCnt].wtrtmpOvcd,
      conductOvcd: obsData[qwCnt].conductOvcd,
      doxOvcd: obsData[qwCnt].doxOvcd,
      phOvcd: obsData[qwCnt].phOvcd,
      turbdtyOvcd: obsData[qwCnt].turbdtyOvcd,
      codOvcd: obsData[qwCnt].codOvcd,
      amnOvcd: obsData[qwCnt].amnOvcd,
      sltOvcd: obsData[qwCnt].sltOvcd,
      wtrtmpCcd: obsData[qwCnt].wtrtmpCcd,
      conductCcd: obsData[qwCnt].conductCcd,
      doxCcd: obsData[qwCnt].doxCcd,
      phCcd: obsData[qwCnt].phCcd,
      turbdtyCcd: obsData[qwCnt].turbdtyCcd,
      codCcd: obsData[qwCnt].codCcd,
      amnCcd: obsData[qwCnt].amnCcd,
      sltCcd: obsData[qwCnt].sltCcd,
      tyclsCd: obsData[qwCnt].tyclsCd,
      tysct1Cd: obsData[qwCnt].tysct1Cd,
    };
    nmList.push(nmItem);

    // 拡大表示
    let lgItem = {
      ofcCd: obsData[qwCnt].ofcCd,
      obsCd: obsData[qwCnt].obsCd,
      obsNm: obsData[qwCnt].obsNm,
      obsTime: obsData[qwCnt].obsTime,
      firstItems: [
        {
          desc: "水温",
          val:
            typeof obsData[qwCnt].wtrtmp !== "undefined"
              ? Util.formatFloat(obsData[qwCnt].wtrtmp, 1)
              : null,
          unit: "℃",
          ccd: obsData[qwCnt].wtrtmpCcd,
        },
        {
          desc: "pH",
          val:
            typeof obsData[qwCnt].ph !== "undefined"
              ? Util.formatFloat(obsData[qwCnt].ph, 1)
              : null,
          unit: "pH",
          ccd: obsData[qwCnt].phCcd,
        },
        {
          desc: "DO",
          val:
            typeof obsData[qwCnt].dox !== "undefined"
              ? Util.formatFloat(obsData[qwCnt].dox, 1)
              : null,
          unit: "mg/l",
          ccd: obsData[qwCnt].doxCcd,
        },
        {
          desc: "導電率",
          val:
            typeof obsData[qwCnt].conduct !== "undefined"
              ? Util.formatFloat(obsData[qwCnt].conduct, 1)
              : null,
          unit: "mS/m",
          ccd: obsData[qwCnt].conductCcd,
        },
        // 要素数調整
        {
          desc: "",
          val: "",
          unit: "",
          ccd: null,
        },
      ],
      secondItems: [
        {
          desc: "濁度",
          val:
            typeof obsData[qwCnt].turbdty !== "undefined"
              ? Util.formatFloat(obsData[qwCnt].turbdty, 1)
              : null,
          unit: "度",
          ccd: obsData[qwCnt].turbdtyCcd,
        },
        {
          desc: "COD",
          val:
            typeof obsData[qwCnt].cod !== "undefined"
              ? Util.formatFloat(obsData[qwCnt].cod, 1)
              : null,
          unit: "mg/l",
          ccd: obsData[qwCnt].codCcd,
        },
        {
          desc: "アンモニアイオン",
          val:
            typeof obsData[qwCnt].amn !== "undefined"
              ? Util.formatFloat(obsData[qwCnt].amn, 1)
              : null,
          unit: "mg/l",
          ccd: obsData[qwCnt].amnCcd,
        },
        {
          desc: "塩分濃度",
          val:
            typeof obsData[qwCnt].slt !== "undefined"
              ? Util.formatFloat(obsData[qwCnt].slt, 1)
              : null,
          unit: "mg/l",
          ccd: obsData[qwCnt].sltCcd,
        },
        // 要素数調整
        {
          desc: "",
          val: "",
          unit: "",
          ccd: null,
        },
      ],
      wtrtmpOvcd: obsData[qwCnt].wtrtmpOvcd,
      conductOvcd: obsData[qwCnt].conductOvcd,
      doxOvcd: obsData[qwCnt].doxOvcd,
      phOvcd: obsData[qwCnt].phOvcd,
      turbdtyOvcd: obsData[qwCnt].turbdtyOvcd,
      codOvcd: obsData[qwCnt].codOvcd,
      amnOvcd: obsData[qwCnt].amnOvcd,
      sltOvcd: obsData[qwCnt].sltOvcd,
      wtrtmpCcd: obsData[qwCnt].wtrtmpCcd,
      conductCcd: obsData[qwCnt].conductCcd,
      doxCcd: obsData[qwCnt].doxCcd,
      phCcd: obsData[qwCnt].phCcd,
      turbdtyCcd: obsData[qwCnt].turbdtyCcd,
      codCcd: obsData[qwCnt].codCcd,
      amnCcd: obsData[qwCnt].amnCcd,
      sltCcd: obsData[qwCnt].sltCcd,
      tyclsCd: obsData[qwCnt].tyclsCd,
      tysct1Cd: obsData[qwCnt].tysct1Cd,
    };
    lgList.push(lgItem);
  }
  return {
    nmList: nmList,
    lgList: lgList,
  };
}

/**
 * [海岸]観測所情報
 * @param {*} obsData 海岸観測所情報
 */
function createJsonDataCoastInfo(obsData) {
  // 通常表示用格納用リスト
  let nmList = [];
  // 拡大表示用格納用リスト
  let lgList = [];

  for (var coastCnt in obsData) {
    // 通常表示
    let nmItem = {
      ofcCd: obsData[coastCnt].ofcCd,
      obsCd: obsData[coastCnt].obsCd,
      obsNm: obsData[coastCnt].obsNm,
      obsTime: obsData[coastCnt].obsTime,
      items: [
        {
          desc: "最大波高",
          val:
            typeof obsData[coastCnt].maxwvHght !== "undefined"
              ? Util.formatFloat(obsData[coastCnt].maxwvHght, 2)
              : null,
          unit: "m",
          ccd: obsData[coastCnt].maxwvHghtCcd,
        },
        {
          desc: "潮位",
          val:
            typeof obsData[coastCnt].tidlvl !== "undefined"
              ? Util.formatFloat(obsData[coastCnt].tidlvl, 2)
              : null,
          unit: "T.P.m",
          ccd: obsData[coastCnt].tidlvlCcd,
        },
      ],
      onthwvHghtWarnOvflg: obsData[coastCnt].onthwvHghtWarnOvflg,
      tidlvlWarnOvflg: obsData[coastCnt].tidlvlWarnOvflg,
      avewndSpdWarnOvflg: obsData[coastCnt].avewndSpdWarnOvflg,
      onthwvHghtCautOvflg: obsData[coastCnt].onthwvHghtCautOvflg,
      tidlvlCautOvflg: obsData[coastCnt].tidlvlCautOvflg,
      avewndSpdCautOvflg: obsData[coastCnt].avewndSpdCautOvflg,
      onthwvHghtCcd: obsData[coastCnt].onthwvHghtCcd,
      tidlvlCcd: obsData[coastCnt].tidlvlCcd,
      avewndSpdCcd: obsData[coastCnt].avewndSpdCcd,
      wvHghtCaut: obsData[coastCnt].wvHghtCaut,
      wvHghtWarn: obsData[coastCnt].wvHghtWarn,
      tidlvlCaut: obsData[coastCnt].tidlvlCaut,
      tidlvlWarn: obsData[coastCnt].tidlvlWarn,
      wndSpdCaut: obsData[coastCnt].wndSpdCaut,
      wndSpdWarn: obsData[coastCnt].wndSpdWarn,
    };
    nmList.push(nmItem);

    // 拡大表示
    let lgItem = {
      ofcCd: obsData[coastCnt].ofcCd,
      obsCd: obsData[coastCnt].obsCd,
      obsNm: obsData[coastCnt].obsNm,
      obsTime: obsData[coastCnt].obsTime,
      firstItems: [
        {
          desc: "波高(最大波)",
          val:
            typeof obsData[coastCnt].maxwvHght !== "undefined"
              ? Util.formatFloat(obsData[coastCnt].maxwvHght, 2)
              : null,
          unit: "m",
          ccd: obsData[coastCnt].maxwvHghtCcd,
        },
        {
          desc: "周期(最大波)",
          val:
            typeof obsData[coastCnt].maxwvCycl !== "undefined"
              ? Util.formatFloat(obsData[coastCnt].maxwvCycl, 1)
              : null,
          unit: "s",
          ccd: obsData[coastCnt].maxwvCyclCcd,
        },
        {
          desc: "波高(1/3有義波)",
          val:
            typeof obsData[coastCnt].onthwvHght !== "undefined"
              ? Util.formatFloat(obsData[coastCnt].onthwvHght, 2)
              : null,
          unit: "m",
          ccd: obsData[coastCnt].onthwvHghtCcd,
        },
        {
          desc: "周期(1/3有義波)",
          val:
            typeof obsData[coastCnt].onthwvCycl !== "undefined"
              ? Util.formatFloat(obsData[coastCnt].onthwvCycl, 1)
              : null,
          unit: "s",
          ccd: obsData[coastCnt].onthwvCyclCcd,
        },
        // 要素数調整
        {
          desc: "",
          val: "",
          unit: "",
          ccd: null,
        },
      ],
      secondItems: [
        {
          desc: "潮位",
          val:
            typeof obsData[coastCnt].tidlvl !== "undefined"
              ? Util.formatFloat(obsData[coastCnt].tidlvl, 2)
              : null,
          unit: "T.P.m",
          ccd: obsData[coastCnt].tidlvlCcd,
        },
        {
          desc: "平均風向",
          val: formatWndDir(obsData[coastCnt].avewndDir),
          unit: "",
          ccd: obsData[coastCnt].avewndDirCcd,
        },
        {
          desc: "平均風速",
          val:
            typeof obsData[coastCnt].avewndSpd !== "undefined"
              ? Util.formatFloat(obsData[coastCnt].avewndSpd, 1)
              : null,
          unit: "m/s",
          ccd: obsData[coastCnt].avewndSpdCcd,
        },
        // 要素数調整
        {
          desc: "",
          val: "",
          unit: "",
          ccd: null,
        },
        {
          desc: "",
          val: "",
          unit: "",
          ccd: null,
        },
      ],
      onthwvHghtWarnOvflg: obsData[coastCnt].onthwvHghtWarnOvflg,
      tidlvlWarnOvflg: obsData[coastCnt].tidlvlWarnOvflg,
      avewndSpdWarnOvflg: obsData[coastCnt].avewndSpdWarnOvflg,
      onthwvHghtCautOvflg: obsData[coastCnt].onthwvHghtCautOvflg,
      tidlvlCautOvflg: obsData[coastCnt].tidlvlCautOvflg,
      avewndSpdCautOvflg: obsData[coastCnt].avewndSpdCautOvflg,
      onthwvHghtCcd: obsData[coastCnt].onthwvHghtCcd,
      tidlvlCcd: obsData[coastCnt].tidlvlCcd,
      avewndSpdCcd: obsData[coastCnt].avewndSpdCcd,
      wvHghtCaut: obsData[coastCnt].wvHghtCaut,
      wvHghtWarn: obsData[coastCnt].wvHghtWarn,
      tidlvlCaut: obsData[coastCnt].tidlvlCaut,
      tidlvlWarn: obsData[coastCnt].tidlvlWarn,
      wndSpdCaut: obsData[coastCnt].wndSpdCaut,
      wndSpdWarn: obsData[coastCnt].wndSpdWarn,
    };
    lgList.push(lgItem);
  }
  return {
    nmList: nmList,
    lgList: lgList,
  };
}

/**
 * [積雪深]観測所情報
 * @param {*} obsData 積雪深観測所情報
 */
function createJsonDataSnowInfo(obsData) {
  // 通常表示用格納用リスト
  let nmList = [];
  // 拡大表示用格納用リスト
  let lgList = [];

  for (var snwCnt in obsData) {
    // 通常表示
    let nmItem = {
      ofcCd: obsData[snwCnt].ofcCd,
      obsCd: obsData[snwCnt].obsCd,
      obsNm: obsData[snwCnt].obsNm,
      obsTime: obsData[snwCnt].obsTime,
      items: [
        {
          desc: "積雪深",
          val:
            typeof obsData[snwCnt].snwdp !== "undefined"
              ? obsData[snwCnt].snwdp
              : null,
          unit: "cm",
          ccd: obsData[snwCnt].snwdpCcd,
        },
        {
          desc: "気温",
          val:
            typeof obsData[snwCnt].tmp !== "undefined"
              ? Util.formatFloat(obsData[snwCnt].tmp, 1)
              : null,
          unit: "℃",
          ccd: obsData[snwCnt].tmpCcd,
        },
      ],
      snwdpCcd: obsData[snwCnt].snwdpCcd,
    };
    nmList.push(nmItem);

    // 拡大表示
    let lgItem = {
      ofcCd: obsData[snwCnt].ofcCd,
      obsCd: obsData[snwCnt].obsCd,
      obsNm: obsData[snwCnt].obsNm,
      obsTime: obsData[snwCnt].obsTime,
      items: [
        {
          desc: "積雪深",
          val:
            typeof obsData[snwCnt].snwdp !== "undefined"
              ? obsData[snwCnt].snwdp
              : null,
          unit: "cm",
          ccd: obsData[snwCnt].snwdpCcd,
        },
        {
          desc: "気温",
          val:
            typeof obsData[snwCnt].tmp !== "undefined"
              ? Util.formatFloat(obsData[snwCnt].tmp, 1)
              : null,
          unit: "℃",
          ccd: obsData[snwCnt].tmpCcd,
        },
        // 要素数調整
        {
          desc: "",
          val: "",
          unit: "",
          ccd: null,
        },
        {
          desc: "",
          val: "",
          unit: "",
          ccd: null,
        },
        {
          desc: "",
          val: "",
          unit: "",
          ccd: null,
        },
        {
          desc: "",
          val: "",
          unit: "",
          ccd: null,
        },
      ],
      snwdpCcd: obsData[snwCnt].snwdpCcd,
    };
    lgList.push(lgItem);
  }
  return {
    nmList: nmList,
    lgList: lgList,
  };
}

/**
 * [危機管理水位]観測所情報
 * @param {*} obsData 危機管理水位観測所情報
 */
function createJsonDataSwstgInfo(obsData) {
  // 通常表示用格納用リスト
  let nmList = [];
  // 拡大表示用格納用リスト
  let lgList = [];

  for (var swstgCnt in obsData) {
    // 通常表示
    let nmItem = {
      swofcCd: obsData[swstgCnt].swofcCd,
      swobsCd: obsData[swstgCnt].swobsCd,
      swobsNm: obsData[swstgCnt].swobsNm,
      obsTime: obsData[swstgCnt].obsTime,
      items: [
        {
          desc: "堤防天端からの高さ",
          val:
            typeof obsData[swstgCnt].stgHght !== "undefined"
              ? Util.formatFloat(obsData[swstgCnt].stgHght, 2)
              : null,
          unit: "m",
          stgQmflg: obsData[swstgCnt].stgQmflg,
        },
      ],
      swstgOvlvl: obsData[swstgCnt].swstgOvlvl,
      // 内部で設定（未収集：160）
      swstgCcd: obsData[swstgCnt].swstgCcd,
      strtStg: obsData[swstgCnt].strtStg,
      dngStg: obsData[swstgCnt].dngStg,
      fldStg: obsData[swstgCnt].fldStg,
      errCd: obsData[swstgCnt].errCd,
    };
    nmList.push(nmItem);
    // 拡大表示
    let lgItem = {
      swofcCd: obsData[swstgCnt].swofcCd,
      swobsCd: obsData[swstgCnt].swobsCd,
      swobsNm: obsData[swstgCnt].swobsNm,
      obsTime: obsData[swstgCnt].obsTime,
      items: [
        {
          desc: "堤防天端からの高さ",
          val:
            typeof obsData[swstgCnt].stgHght !== "undefined"
              ? Util.formatFloat(obsData[swstgCnt].stgHght, 2)
              : null,
          unit: "m",
          stgQmflg: obsData[swstgCnt].stgQmflg,
        },
      ],
      swstgOvlvl: obsData[swstgCnt].swstgOvlvl,
      // 内部で設定（未収集：160）
      swstgCcd: obsData[swstgCnt].swstgCcd,
      strtStg: obsData[swstgCnt].strtStg,
      dngStg: obsData[swstgCnt].dngStg,
      fldStg: obsData[swstgCnt].fldStg,
      errCd: obsData[swstgCnt].errCd,
    };
    lgList.push(lgItem);
  }

  return {
    nmList: nmList,
    lgList: lgList,
  };
}

/**
 * [登録地点観測所一覧]表示データ作成
 * @param {*} obsData 観測所情報
 * @param {*} stgMsg 水位表示切替メッセージ設定
 * @param {*} refObs 基準水位観測所メッセージ設定
 */
function convertRpTmList(obsData, stgMsg, refObs) {
  return {
    Stg: createDataRpStgInfo(obsData.tmPointStageList, stgMsg, refObs),
    Dam: createDataRpDamInfo(obsData.tmPointDamList),
    Rain: createDataRpRainInfo(obsData.tmPointRainList),
    Snow: createDataRpSnowInfo(obsData.tmPointSnowList),
    Qwtr: createDataRpQwtrInfo(obsData.tmPointQwtrList),
    Coast: createDataRpCoastInfo(obsData.tmPointCoastList),
    Swstg: createDataRpSwstgInfo(obsData.tmPointswStageList),
  };
}

/**
 * [通常水位]登録地点観測所情報
 * @param {*} obsData 通常水位観測所情報
 * @param {*} stgMsg 水位表示切替メッセージ設定
 * @param {*} refObs 基準水位観測所メッセージ設定
 */
function createDataRpStgInfo(obsData, stgMsg, refObs) {
  // 通常表示用格納用リスト
  let nmList = [];

  for (var stgCnt in obsData) {
    // 通常表示
    let nmItem = {
      ofcCd: obsData[stgCnt].ofcCd,
      obsCd: obsData[stgCnt].obsCd,
      obsNm: [
        obsData[stgCnt].obsNm,
        obsData[stgCnt].obsNm + refObs.referenceObs,
      ],
      obsTime: obsData[stgCnt].obsTime,
      items: [
        {
          // 零点高から
          desc: stgMsg.normalStgHght,
          val:
            typeof obsData[stgCnt].stg !== "undefined"
              ? Util.formatFloat(obsData[stgCnt].stg, 2)
              : null,
          unit: "m",
          stgQmflg: obsData[stgCnt].stgQmflg,
        },
        {
          // 堤防天端から
          desc: stgMsg.topendStgHght,
          val:
            typeof obsData[stgCnt].stgHght !== "undefined"
              ? Util.formatFloat(obsData[stgCnt].stgHght, 2)
              : null,
          unit: "m",
          stgQmflg: obsData[stgCnt].stgQmflg,
        },
      ],
      stgLtstChg: obsData[stgCnt].stgLtstChg,
      stg10mChg: obsData[stgCnt].stg10mChg,
      stg10mChgCcd: obsData[stgCnt].stg10mChgCcd,
      stgOvlvl: obsData[stgCnt].stgOvlvl,
      stgCcd: obsData[stgCnt].stgCcd,
      rsrvStg: obsData[stgCnt].rsrvStg,
      warnStg: obsData[stgCnt].warnStg,
      spclWarnStg: obsData[stgCnt].spclWarnStg,
      dngStg: obsData[stgCnt].dngStg,
      fldStg: obsData[stgCnt].fldStg,
      dspFlg: obsData[stgCnt].dspFlg,
      fldfrFlg: obsData[stgCnt].fldfrFlg,
      evstgFlg: obsData[stgCnt].evstgFlg,
      fldctlFlg: obsData[stgCnt].fldctlFlg,
    };
    nmList.push(nmItem);
  }

  return {
    nmList: nmList,
  };
}

/**
 * [ダム諸量]登録地点観測所情報
 * @param {*} obsData ダム諸量観測所情報
 */
function createDataRpDamInfo(obsData) {
  // 通常表示用格納用リスト
  let nmList = [];

  for (var damCnt in obsData) {
    // 通常表示
    let nmItem = {
      ofcCd: obsData[damCnt].ofcCd,
      obsCd: obsData[damCnt].obsCd,
      obsNm: obsData[damCnt].obsNm,
      obsTime: obsData[damCnt].obsTime,
      items: [
        {
          desc: "貯水位",
          val: obsData[damCnt].storLvl,
          unit: "m",
          ccd: obsData[damCnt].storLvlCcd,
        },
        {
          desc: "貯水率有効容量",
          val: Util.formatFloat(obsData[damCnt].storPcntEff, 1),
          unit: "%",
          ccd: obsData[damCnt].storPcntEffCcd,
        },
      ],
      damdschLvl: obsData[damCnt].damdschLvl,
      storLvlCcd: obsData[damCnt].storLvlCcd,
      storCapCcd: obsData[damCnt].storCapCcd,
      storPcntIrrCcd: obsData[damCnt].storPcntIrrCcd,
      allSinkCcd: obsData[damCnt].allSinkCcd,
      allDischCcd: obsData[damCnt].allDischCcd,
      storPcntEffCcd: obsData[damCnt].storPcntEffCcd,
      rwNoticeMng: obsData[damCnt].rwNoticeMng,
    };
    nmList.push(nmItem);
  }

  return {
    nmList: nmList,
  };
}

/**
 * [雨量]登録地点観測所情報
 * @param {*} obsData 雨量観測所情報
 */
function createDataRpRainInfo(obsData) {
  // 通常表示用格納用リスト
  let nmList = [];

  for (var rnCnt in obsData) {
    // 通常表示
    let nmItem = {
      ofcCd: obsData[rnCnt].ofcCd,
      obsCd: obsData[rnCnt].obsCd,
      obsNm: obsData[rnCnt].obsNm,
      obsTime: obsData[rnCnt].obsTime,
      items: [
        {
          desc: "10分雨量",
          val: obsData[rnCnt].rn10m,
          unit: "mm",
          ccd: obsData[rnCnt].rn10mCcd,
        },
        {
          desc: "累加雨量",
          val: obsData[rnCnt].rnInc,
          unit: "mm",
          ccd: obsData[rnCnt].rnIncCcd,
        },
      ],
      rn10mCcd: obsData[rnCnt].rn10mCcd,
      rnHr10mCcd: obsData[rnCnt].rnHr10mCcd,
      rnIncCcd: obsData[rnCnt].rnIncCcd,
      rn60mCcd: obsData[rnCnt].rn60mCcd,
    };
    nmList.push(nmItem);
  }

  return {
    nmList: nmList,
  };
}

/**
 * [積雪深]登録地点観測所情報
 * @param {*} obsData 積雪深観測所情報
 */
function createDataRpSnowInfo(obsData) {
  // 通常表示用格納用リスト
  let nmList = [];

  for (var snwCnt in obsData) {
    // 通常表示
    let nmItem = {
      ofcCd: obsData[snwCnt].ofcCd,
      obsCd: obsData[snwCnt].obsCd,
      obsNm: obsData[snwCnt].obsNm,
      obsTime: obsData[snwCnt].obsTime,
      items: [
        {
          desc: "積雪深",
          val: obsData[snwCnt].snwdp,
          unit: "cm",
          ccd: obsData[snwCnt].snwdpCcd,
        },
        {
          desc: "気温",
          val: obsData[snwCnt].tmp,
          unit: "℃",
          ccd: obsData[snwCnt].tmpCcd,
        },
      ],
      snwdpCcd: obsData[snwCnt].snwdpCcd,
    };
    nmList.push(nmItem);
  }
  return {
    nmList: nmList,
  };
}

// /**
//  * [河川カメラ]登録地点観測所情報
//  * @param {*} obsData 河川カメラ観測所情報
//  */
// function createDataRpCctvInfo(obsData) {
//   // 通常表示用格納用リスト
//   let nmList = [];
//   for (var cctvCnt in obsData ) {
//     // 通常表示
//     let nmItem = {
//       ofcCd: obsData[cctvCnt].ofcCd,
//       cctvCd: obsData[cctvCnt].cctvCd,
//       cctvNm: obsData[cctvCnt].cctvNm,
//       obsTime: obsData[cctvCnt].obsTime,
//       items: []
//     };
//     nmList.push(nmItem);
//   }
//   return {
//     nmList: nmList
//   };
// }

/**
 * [水質]登録地点観測所情報
 * @param {*} obsData 水質観測所情報
 */
function createDataRpQwtrInfo(obsData) {
  // 通常表示用格納用リスト
  let nmList = [];

  for (var qwCnt in obsData) {
    // 通常表示
    let nmItem = {
      ofcCd: obsData[qwCnt].ofcCd,
      obsCd: obsData[qwCnt].obsCd,
      obsNm: obsData[qwCnt].obsNm,
      obsTime: obsData[qwCnt].obsTime,
      items: [
        {
          desc: "水温",
          val: obsData[qwCnt].wtrtmp,
          unit: "℃",
          ccd: obsData[qwCnt].wtrtmpCcd,
        },
        {
          desc: "濁度",
          val: obsData[qwCnt].turbdty,
          unit: "度",
          ccd: obsData[qwCnt].turbdtyCcd,
        },
      ],
      wtrtmpOvcd: obsData[qwCnt].wtrtmpOvcd,
      conductOvcd: obsData[qwCnt].conductOvcd,
      doxOvcd: obsData[qwCnt].doxOvcd,
      phOvcd: obsData[qwCnt].phOvcd,
      turbdtyOvcd: obsData[qwCnt].turbdtyOvcd,
      codOvcd: obsData[qwCnt].codOvcd,
      amnOvcd: obsData[qwCnt].amnOvcd,
      sltOvcd: obsData[qwCnt].sltOvcd,
      wtrtmpCcd: obsData[qwCnt].wtrtmpCcd,
      conductCcd: obsData[qwCnt].conductCcd,
      doxCcd: obsData[qwCnt].doxCcd,
      phCcd: obsData[qwCnt].phCcd,
      turbdtyCcd: obsData[qwCnt].turbdtyCcd,
      codCcd: obsData[qwCnt].codCcd,
      amnCcd: obsData[qwCnt].amnCcd,
      sltCcd: obsData[qwCnt].sltCcd,
      tyclsCd: obsData[qwCnt].tyclsCd,
      tysct1Cd: obsData[qwCnt].tysct1Cd,
    };
    nmList.push(nmItem);
  }
  return {
    nmList: nmList,
  };
}

/**
 * [海岸]登録地点観測所情報
 * @param {*} obsData 海岸観測所情報
 */
function createDataRpCoastInfo(obsData) {
  // 通常表示用格納用リスト
  let nmList = [];

  for (var coastCnt in obsData) {
    // 通常表示
    let nmItem = {
      ofcCd: obsData[coastCnt].ofcCd,
      obsCd: obsData[coastCnt].obsCd,
      obsNm: obsData[coastCnt].obsNm,
      obsTime: obsData[coastCnt].obsTime,
      items: [
        {
          desc: "最大波高",
          val: obsData[coastCnt].maxwvHght,
          unit: "m",
          ccd: obsData[coastCnt].maxwvHghtCcd,
        },
        {
          desc: "潮位",
          val: obsData[coastCnt].tidlvl,
          unit: "T.P.m",
          ccd: obsData[coastCnt].tidlvlCcd,
        },
      ],
      onthwvHghtWarnOvflg: obsData[coastCnt].onthwvHghtWarnOvflg,
      tidlvlWarnOvflg: obsData[coastCnt].tidlvlWarnOvflg,
      avewndSpdWarnOvflg: obsData[coastCnt].avewndSpdWarnOvflg,
      onthwvHghtCautOvflg: obsData[coastCnt].onthwvHghtCautOvflg,
      tidlvlCautOvflg: obsData[coastCnt].tidlvlCautOvflg,
      avewndSpdCautOvflg: obsData[coastCnt].avewndSpdCautOvflg,
      onthwvHghtCcd: obsData[coastCnt].onthwvHghtCcd,
      tidlvlCcd: obsData[coastCnt].tidlvlCcd,
      avewndSpdCcd: obsData[coastCnt].avewndSpdCcd,
      wvHghtCaut: obsData[coastCnt].wvHghtCaut,
      wvHghtWarn: obsData[coastCnt].wvHghtWarn,
      tidlvlCaut: obsData[coastCnt].tidlvlCaut,
      tidlvlWarn: obsData[coastCnt].tidlvlWarn,
      wndSpdCaut: obsData[coastCnt].wndSpdCaut,
      wndSpdWarn: obsData[coastCnt].wndSpdWarn,
    };
    nmList.push(nmItem);
  }
  return {
    nmList: nmList,
  };
}

/**
 * [危機管理]登録地点観測所情報
 * @param {*} obsData 危機管理水位観測所情報
 */
function createDataRpSwstgInfo(obsData) {
  // 通常表示用格納用リスト
  let nmList = [];

  for (var swstgCnt in obsData) {
    let nmItem = {
      swofcCd: obsData[swstgCnt].swofcCd,
      swobsCd: obsData[swstgCnt].swobsCd,
      swobsNm: obsData[swstgCnt].swobsNm,
      obsTime: obsData[swstgCnt].obsTime,
      items: [
        {
          desc: "堤防天端からの高さ",
          val: obsData[swstgCnt].stg,
          unit: "m",
          stgQmFlg: obsData[swstgCnt].stgQmFlg,
        },
      ],
      swstgOvlvl: obsData[swstgCnt].swstgOvlvl,
      // 内部で設定（未収集：160）
      swstgCcd: obsData[swstgCnt].swstgCcd,
      strtStg: obsData[swstgCnt].strtStg,
      dngStg: obsData[swstgCnt].dngStg,
      fldStg: obsData[swstgCnt].fldStg,
    };
    nmList.push(nmItem);
  }
  return {
    nmList: nmList,
  };
}

/**
 * [拡大表示用ダム諸量観測所情報]
 * @param {*} obsData 観測所情報
 */
function getRelatLgList(obsData) {
  let result = [];
  if (
    obsData.relatTmObsFcd !== null &&
    obsData.relatTmObsFcd !== "0000000000000"
  ) {
    result = {
      ofcCd: obsData.ofcCd,
      obsCd: obsData.obsCd,
      obsNm: obsData.obsNm,
      obsTime: obsData.obsTime,
      firstItems: [
        {
          desc: "貯水位",
          val:
            typeof obsData.storLvl !== "undefined"
              ? Util.formatFloat(obsData.storLvl, 2)
              : null,
          unit: "m",
          ccd: obsData.storLvlCcd,
        },
        {
          desc: "貯水量",
          val:
            typeof obsData.storCap !== "undefined"
              ? Util.formatFloat(obsData.storCap, 2)
              : null,
          unit: "千㎥",
          ccd: obsData.storCapCcd,
        },
        {
          desc: "利水容量",
          val: Util.formatFloat(obsData.storPcntIrr, 1),
          unit: "%",
          ccd: obsData.storPcntIrrCcd,
        },
        {
          desc: "有効容量",
          val: Util.formatFloat(obsData.storPcntEff, 1),
          unit: "%",
          ccd: obsData.storPcntEffCcd,
        },
        {
          desc: "治水容量",
          val: Util.formatFloat(obsData.storFcntIrr, 1),
          unit: "%",
          ccd: obsData.storFcntIrrCcd,
        },
        // 要素数調整
        {
          desc: "",
          val: "",
          unit: "",
          ccd: null,
        },
      ],
      secondItems: [
        {
          desc: "全流入量",
          val:
            typeof obsData.allSink !== "undefined"
              ? Util.formatFloat(obsData.allSink, 2)
              : null,
          unit: "㎥/s",
          ccd: obsData.allSinkCcd,
        },
        {
          desc: "全放流量",
          val:
            typeof obsData.allDisch !== "undefined"
              ? Util.formatFloat(obsData.allDisch, 2)
              : null,
          unit: "㎥/s",
          ccd: obsData.allDischCcd,
        },
        {
          desc: "時間雨量",
          val:
            typeof obsData.bsnrnHr10m !== "undefined"
              ? Util.formatFloat(obsData.bsnrnHr10m, 1)
              : null,
          unit: "mm",
          ccd: obsData.bsnrnHr10mCcd,
        },
        {
          desc: "累加雨量",
          val:
            typeof obsData.bsnrnInc !== "undefined"
              ? Util.formatFloat(obsData.bsnrnInc, 1)
              : null,
          unit: "mm",
          ccd: obsData.bsnrnIncCcd,
        },
        // 要素数調整
        {
          desc: "",
          val: "",
          unit: "",
          ccd: null,
        },
        {
          desc: "",
          val: "",
          unit: "",
          ccd: null,
        },
      ],
      damdschLvl: obsData.damdschLvl,
      storLvlCcd: obsData.storLvlCcd,
      storCapCcd: obsData.storCapCcd,
      storPcntIrrCcd: obsData.storPcntIrrCcd,
      allSinkCcd: obsData.allSinkCcd,
      allDischCcd: obsData.allDischCcd,
      storPcntEffCcd: obsData.storPcntEffCcd,
    };
  } else if (
    obsData.relatRdObsFcd !== null &&
    obsData.relatRdObsFcd !== "0000000000000"
  ) {
    result = {
      ofcCd: obsData.ofcCd,
      obsCd: obsData.obsCd,
      obsNm: obsData.obsNm,
      obsTime: obsData.obsTime,
      firstItems: [
        {
          desc: "貯水位",
          val:
            typeof obsData.storLvl !== "undefined"
              ? Util.formatFloat(obsData.storLvl, 2)
              : null,
          unit: "m",
          ccd: obsData.storLvlCcd,
        },
        {
          desc: "貯水量",
          val:
            typeof obsData.storCap !== "undefined"
              ? Util.formatFloat(obsData.storCap, 2)
              : null,
          unit: "千㎥",
          ccd: obsData.storCapCcd,
        },
        {
          desc: "利水容量",
          val: obsData.storPcntIrr,
          unit: "%",
          ccd: obsData.storPcntIrrCcd,
        },
        {
          desc: "有効容量",
          val: obsData.storPcntEff,
          unit: "%",
          ccd: obsData.storPcntEffCcd,
        },
        {
          desc: "治水容量",
          val: obsData.storFcntIrr,
          unit: "%",
          ccd: obsData.storFcntIrrCcd,
        },
        // 要素数調整
        {
          desc: "",
          val: "",
          unit: "",
          ccd: null,
        },
      ],
      secondItems: [
        {
          desc: "全流入量",
          val:
            typeof obsData.allSink !== "undefined"
              ? Util.formatFloat(obsData.allSink, 2)
              : null,
          unit: "㎥/s",
          ccd: obsData.allSinkCcd,
        },
        {
          desc: "全放流量",
          val:
            typeof obsData.allDisch !== "undefined"
              ? Util.formatFloat(obsData.allDisch, 2)
              : null,
          unit: "㎥/s",
          ccd: obsData.allDischCcd,
        },
        {
          desc: "時間雨量",
          val:
            typeof obsData.rdbsnrnHr10m !== "undefined"
              ? Util.formatFloat(obsData.rdbsnrnHr10m, 1)
              : null,
          unit: "mm",
          ccd: obsData.rdbsnrnHr10mCcd,
        },
        {
          desc: "累加雨量",
          val:
            typeof obsData.rdbsnrnInc !== "undefined"
              ? Util.formatFloat(obsData.rdbsnrnInc, 1)
              : null,
          unit: "mm",
          ccd: obsData.rdbsnrnIncCcd,
        },
        // 要素数調整
        {
          desc: "",
          val: "",
          unit: "",
          ccd: null,
        },
        {
          desc: "",
          val: "",
          unit: "",
          ccd: null,
        },
      ],
      damdschLvl: obsData.damdschLvl,
      storLvlCcd: obsData.storLvlCcd,
      storCapCcd: obsData.storCapCcd,
      storPcntIrrCcd: obsData.storPcntIrrCcd,
      allSinkCcd: obsData.allSinkCcd,
      allDischCcd: obsData.allDischCcd,
      storPcntEffCcd: obsData.storPcntEffCcd,
    };
  } else {
    result = {
      ofcCd: obsData.ofcCd,
      obsCd: obsData.obsCd,
      obsNm: obsData.obsNm,
      obsTime: obsData.obsTime,
      firstItems: [
        {
          desc: "貯水位",
          val:
            typeof obsData.storLvl !== "undefined"
              ? Util.formatFloat(obsData.storLvl, 2)
              : null,
          unit: "m",
          ccd: obsData.storLvlCcd,
        },
        {
          desc: "貯水量",
          val:
            typeof obsData.storCap !== "undefined"
              ? Util.formatFloat(obsData.storCap, 2)
              : null,
          unit: "千㎥",
          ccd: obsData.storCapCcd,
        },
        {
          desc: "利水容量",
          val: obsData.storPcntIrr,
          unit: "%",
          ccd: obsData.storPcntIrrCcd,
        },
        {
          desc: "有効容量",
          val: obsData.storPcntEff,
          unit: "%",
          ccd: obsData.storPcntEffCcd,
        },
        {
          desc: "治水容量",
          val: obsData.storFcntIrr,
          unit: "%",
          ccd: obsData.storFcntIrrCcd,
        },
        // 要素数調整
        {
          desc: "",
          val: "",
          unit: "",
          ccd: null,
        },
      ],
      secondItems: [
        {
          desc: "全流入量",
          val:
            typeof obsData.allSink !== "undefined"
              ? Util.formatFloat(obsData.allSink, 2)
              : null,
          unit: "㎥/s",
          ccd: obsData.allSinkCcd,
        },
        {
          desc: "全放流量",
          val:
            typeof obsData.allDisch !== "undefined"
              ? Util.formatFloat(obsData.allDisch, 2)
              : null,
          unit: "㎥/s",
          ccd: obsData.allDischCcd,
        },
        {
          desc: "時間雨量",
          val: null,
          unit: "mm",
          ccd: null,
        },
        {
          desc: "累加雨量",
          val: null,
          unit: "mm",
          ccd: null,
        },
        // 要素数調整
        {
          desc: "",
          val: "",
          unit: "",
          ccd: null,
        },
        {
          desc: "",
          val: "",
          unit: "",
          ccd: null,
        },
      ],
      damdschLvl: obsData.damdschLvl,
      storLvlCcd: obsData.storLvlCcd,
      storCapCcd: obsData.storCapCcd,
      storPcntIrrCcd: obsData.storPcntIrrCcd,
      allSinkCcd: obsData.allSinkCcd,
      allDischCcd: obsData.allDischCcd,
      storPcntEffCcd: obsData.storPcntEffCcd,
    };
  }
  return result;
}

/**
 * 水位観測所アイコン
 * @param {*} stageItem 水位観測所情報
 * @param {*} isFldCtl 水防団モード
 */
function setStageIcon(stageItem, isFldCtl) {
  // 平常
  var stageIcon = "/kawabou/img/obs_icons/obs_water_normal.svg";
  if (
    typeof stageItem.stgCcd !== "undefined" &&
    (stageItem.stgCcd >= 128 || stageItem.stgCcd == null)
  ) {
    // 欠測
    stageIcon = "/kawabou/img/obs_icons/obs_water_missing.svg";
  } else if (stageItem.stgOvlvl === 90) {
    // 氾濫発生
    if (stageItem.stg10mChg > 0) {
      stageIcon = "/kawabou/img/obs_icons/obs_water_flood_up.svg";
    } else if (stageItem.stg10mChg < 0) {
      stageIcon = "/kawabou/img/obs_icons/obs_water_flood_down.svg";
    } else {
      stageIcon = "/kawabou/img/obs_icons/obs_water_flood.svg";
    }
  } else if (
    stageItem.rsrvStg === null &&
    stageItem.warnStg === null &&
    stageItem.spclWarnStg === null &&
    stageItem.dngStg === null
  ) {
    // 基準水位未設定
    stageIcon = "/kawabou/img/obs_icons/obs_water_notset.svg";
  } else if (stageItem.stgOvlvl === 80 || stageItem.stgOvlvl === 70) {
    // 氾濫危険水位超過
    if (stageItem.stg10mChg > 0) {
      stageIcon = "/kawabou/img/obs_icons/obs_water_danger_up.svg";
    } else if (stageItem.stg10mChg < 0) {
      stageIcon = "/kawabou/img/obs_icons/obs_water_danger_down.svg";
    } else {
      stageIcon = "/kawabou/img/obs_icons/obs_water_danger.svg";
    }
  } else if (stageItem.stgOvlvl === 60 || stageItem.stgOvlvl === 50) {
    // 避難判断水位超過
    if (stageItem.stg10mChg > 0) {
      stageIcon = "/kawabou/img/obs_icons/obs_water_refuge_up.svg";
    } else if (stageItem.stg10mChg < 0) {
      stageIcon = "/kawabou/img/obs_icons/obs_water_refuge_down.svg";
    } else {
      stageIcon = "/kawabou/img/obs_icons/obs_water_refuge.svg";
    }
  } else if (
    stageItem.stgOvlvl === 40 ||
    stageItem.stgOvlvl === 30 ||
    stageItem.stgOvlvl === 20
  ) {
    // 氾濫注意水位超過
    if (stageItem.stg10mChg > 0) {
      stageIcon = "/kawabou/img/obs_icons/obs_water_caution_up.svg";
    } else if (stageItem.stg10mChg < 0) {
      stageIcon = "/kawabou/img/obs_icons/obs_water_caution_down.svg";
    } else {
      stageIcon = "/kawabou/img/obs_icons/obs_water_caution.svg";
    }
  } else if (isFldCtl && stageItem.stgOvlvl === 10) {
    // 水防団モードの場合、水防団待機水位超過
    if (stageItem.stg10mChg > 0) {
      stageIcon = "/kawabou/img/obs_icons/obs_water_fldctl_up.svg";
    } else if (stageItem.stg10mChg < 0) {
      stageIcon = "/kawabou/img/obs_icons/obs_water_fldctl_down.svg";
    } else {
      stageIcon = "/kawabou/img/obs_icons/obs_water_fldctl.svg";
    }
  }
  return stageIcon;
}

/**
 * ダム観測所アイコン
 * @param {*} stageItem ダム観測所情報
 */
function setDamIcon(damItem) {
  // 平常
  var damIcon = "/kawabou/img/obs_icons/obs_dam_normal.svg";
  if (damItem.damdschLvl === 70) {
    // 異常洪水時防災操作等実施中
    damIcon = "/kawabou/img/obs_icons/obs_dam_abnormal.svg";
  } else if (damItem.damdschLvl === 50) {
    // 洪水貯留操作実施中
    damIcon = "/kawabou/img/obs_icons/obs_dam_storage.svg";

  } else if (typeof damItem.storLvlCcd !== "undefined" &&
    (damItem.storLvlCcd >= 128 || damItem.storLvlCcd == null) &&
    typeof damItem.storCapCcd !== "undefined" &&
    (damItem.storCapCcd >= 128 || damItem.storCapCcd == null) &&
    typeof damItem.storPcntIrrCcd !== "undefined" &&
    (damItem.storPcntIrrCcd >= 128 || damItem.storPcntIrrCcd == null) &&
    typeof damItem.allSinkCcd !== "undefined" &&
    (damItem.allSinkCcd >= 128 || damItem.allSinkCcd == null) &&
    typeof damItem.allDischCcd !== "undefined" &&
    (damItem.allDischCcd >= 128 || damItem.allDischCcd == null) &&
    typeof damItem.storPcntEffCcd !== "undefined" &&
    (damItem.storPcntEffCcd >= 128 || damItem.storPcntEffCcd == null)
  ) {
    // 欠測
    damIcon = "/kawabou/img/obs_icons/obs_dam_missing.svg";
  } else if (damItem.rwNoticeMng === 0) {
    // 管理外
    damIcon = "/kawabou/img/obs_icons/obs_dam_notset.svg";
  }
  return damIcon;
}

/**
 * 河川カメラアイコン
 */
function setCctvIcon() {
  var cctvIcon = "/kawabou/img/obs_icons/obs_cctv_river.svg";
  return cctvIcon;
}

/**
 * 雨量観測所アイコン
 * @param {*} stageItem 雨量観測所情報
 */
function setRainIcon(rainItem) {
  // 平常
  var rainIcon = "/kawabou/img/obs_icons/obs_rain_normal.svg";
  if (
    typeof rainItem.rn10mCcd !== "undefined" &&
    (rainItem.rn10mCcd >= 128 || rainItem.rn10mCcd == null) &&
    typeof rainItem.rnHr10mCcd !== "undefined" &&
    (rainItem.rnHr10mCcd >= 128 || rainItem.rnHr10mCcd == null) &&
    typeof rainItem.rnIncCcd !== "undefined" &&
    (rainItem.rnIncCcd >= 128 || rainItem.rnIncCcd == null) &&
    typeof rainItem.rn60mCcd !== "undefined" &&
    (rainItem.rn60mCcd >= 128 || rainItem.rn60mCcd == null)
  ) {
    // 欠測
    rainIcon = "/kawabou/img/obs_icons/obs_rain_missing.svg";
  }
  return rainIcon;
}

/**
 * 水質観測所アイコン
 * @param {*} stageItem 水質観測所情報
 */
function setWtrQualIcon(wtrQualItem) {
  // 平常
  var wtrQualIcon = "/kawabou/img/obs_icons/obs_quality_normal.svg";
  if (
    typeof wtrQualItem.wtrtmpCcd !== "undefined" &&
    (wtrQualItem.wtrtmpCcd >= 128 || wtrQualItem.wtrtmpCcd == null) &&
    typeof wtrQualItem.conductCcd !== "undefined" &&
    (wtrQualItem.conductCcd >= 128 || wtrQualItem.conductCcd == null) &&
    typeof wtrQualItem.doxCcd !== "undefined" &&
    (wtrQualItem.doxCcd >= 128 || wtrQualItem.doxCcd == null) &&
    typeof wtrQualItem.phCcd !== "undefined" &&
    (wtrQualItem.phCcd >= 128 || wtrQualItem.phCcd == null) &&
    typeof wtrQualItem.turbdtyCcd !== "undefined" &&
    (wtrQualItem.turbdtyCcd >= 128 || wtrQualItem.turbdtyCcd == null) &&
    typeof wtrQualItem.codCcd !== "undefined" &&
    (wtrQualItem.codCcd >= 128 || wtrQualItem.codCcd == null) &&
    typeof wtrQualItem.amnCcd !== "undefined" &&
    (wtrQualItem.amnCcd >= 128 || wtrQualItem.amnCcd == null) &&
    typeof wtrQualItem.sltCcd !== "undefined" &&
    (wtrQualItem.sltCcd >= 128 || wtrQualItem.sltCcd == null)
  ) {
    // 欠測
    wtrQualIcon = "/kawabou/img/obs_icons/obs_quality_missing.svg";
  } else if (wtrQualItem.tyclsCd === 0 || wtrQualItem.tysct1Cd === 0) {
    // 類型指定なし
    wtrQualIcon = "/kawabou/img/obs_icons/obs_quality_notset.svg";
  } else if (
    (wtrQualItem.wtrtmpOvcd && wtrQualItem.wtrtmpOvcd !== 0) ||
    (wtrQualItem.conductOvcd && wtrQualItem.conductOvcd !== 0) ||
    (wtrQualItem.doxOvcd && wtrQualItem.doxOvcd !== 0) ||
    (wtrQualItem.phOvcd && wtrQualItem.phOvcd !== 0) ||
    (wtrQualItem.turbdtyOvcd && wtrQualItem.turbdtyOvcd !== 0) ||
    (wtrQualItem.codOvcd && wtrQualItem.codOvcd !== 0) ||
    (wtrQualItem.amnOvcd && wtrQualItem.amnOvcd !== 0) ||
    (wtrQualItem.sltOvcd && wtrQualItem.sltOvcd !== 0)
  ) {
    // 基準値超過
    wtrQualIcon = "/kawabou/img/obs_icons/obs_quality_excess.svg";
  }
  return wtrQualIcon;
}

/**
 * 海岸観測所アイコン
 * @param {*} stageItem 海岸観測所情報
 */
function setCoastIcon(coastItem) {
  // 平常
  var coastIcon = "/kawabou/img/obs_icons/obs_sea_normal.svg";
  if (
    typeof coastItem.onthwvHghtCcd !== "undefined" &&
    (coastItem.onthwvHghtCcd >= 128 || coastItem.onthwvHghtCcd == null) &&
    typeof coastItem.tidlvlCcd !== "undefined" &&
    (coastItem.tidlvlCcd >= 128 || coastItem.tidlvlCcd == null) &&
    typeof coastItem.avewndSpdCcd !== "undefined" &&
    (coastItem.avewndSpdCcd >= 128 || coastItem.avewndSpdCcd == null)
  ) {
    // 欠測
    coastIcon = "/kawabou/img/obs_icons/obs_sea_missing.svg";
  } else if (
    coastItem.wvHghtCaut === null &&
    coastItem.wvHghtWarn === null &&
    coastItem.tidlvlCaut === null &&
    coastItem.tidlvlWarn === null &&
    coastItem.wndSpdCaut === null &&
    coastItem.wndSpdWarn === null
  ) {
    // 基準値未設定
    coastIcon = "/kawabou/img/obs_icons/obs_sea_notset.svg";
  } else if (
    (coastItem.onthwvHghtWarnOvflg && coastItem.onthwvHghtWarnOvflg !== 0) ||
    (coastItem.tidlvlWarnOvflg && coastItem.tidlvlWarnOvflg !== 0) ||
    (coastItem.avewndSpdWarnOvflg && coastItem.avewndSpdWarnOvflg !== 0)
  ) {
    // 警戒値超過
    coastIcon = "/kawabou/img/obs_icons/obs_sea_warning.svg";
  } else if (
    (coastItem.onthwvHghtCautOvflg && coastItem.onthwvHghtCautOvflg !== 0) ||
    (coastItem.tidlvlCautOvflg && coastItem.tidlvlCautOvflg !== 0) ||
    (coastItem.avewndSpdCautOvflg && coastItem.avewndSpdCautOvflg !== 0)
  ) {
    // 注意値超過
    coastIcon = "/kawabou/img/obs_icons/obs_sea_caution.svg";
  }
  return coastIcon;
}

/**
 * 積雪観測所アイコン
 * @param {*} stageItem 積雪観測所情報
 */
function setSnowIcon(snowItem) {
  // 0cm
  var snowIcon = "/kawabou/img/obs_icons/obs_snow_0.svg";
  if (
    typeof snowItem.snwdpCcd !== "undefined" &&
    (snowItem.snwdpCcd >= 128 || snowItem.snwdpCcd == null)
  ) {
    // 欠測
    snowIcon = "/kawabou/img/obs_icons/obs_snow_missing.svg";
  } else if (snowItem.items[0].val >= 200) {
    // 200cm以上
    snowIcon = "/kawabou/img/obs_icons/obs_snow_200.svg";
  } else if (snowItem.items[0].val >= 150) {
    // 150cm～199cm
    snowIcon = "/kawabou/img/obs_icons/obs_snow_150.svg";
  } else if (snowItem.items[0].val >= 100) {
    // 100cm～149cm
    snowIcon = "/kawabou/img/obs_icons/obs_snow_100.svg";
  } else if (snowItem.items[0].val >= 50) {
    // 50cm～99cm
    snowIcon = "/kawabou/img/obs_icons/obs_snow_50.svg";
  } else if (snowItem.items[0].val >= 20) {
    // 20cm～49cm
    snowIcon = "/kawabou/img/obs_icons/obs_snow_20.svg";
  } else if (snowItem.items[0].val >= 5) {
    // 5cm～19cm
    snowIcon = "/kawabou/img/obs_icons/obs_snow_5.svg";
  } else if (snowItem.items[0].val > 0) {
    // 0cm～4cm
    snowIcon = "/kawabou/img/obs_icons/obs_snow_0_over.svg";
  }
  return snowIcon;
}

/**
 * 簡易カメラアイコン
 */
function setScamIcon() {
  var scamIcon = "/kawabou/img/obs_icons/obs_scam_river.svg";
  return scamIcon;
}

/**
 * 危機管理水位観測所アイコン
 * @param {*} swinItem 危機管理水位観測所情報
 */
function setSwStageIcon(swinItem) {
  // 平常
  var stageIcon = "/kawabou/img/obs_icons/obs_swstg_normal.svg";
  if (
    typeof swinItem.swstgCcd !== "undefined" &&
    (swinItem.swstgCcd >= 128 || swinItem.swstgCcd == null)
  ) {
    // 観測値が取得出来ない場合、内部的に内容コード160が入る
    stageIcon = "/kawabou/img/obs_icons/obs_swstg_missing.svg";
  } else if (swinItem.swstgOvlvl === 90) {
    // 氾濫開始水位超過
    stageIcon = "/kawabou/img/obs_icons/obs_swstg_flood.svg";
  } else if (swinItem.swstgOvlvl === 80) {
    // 危険水位超過
    stageIcon = "/kawabou/img/obs_icons/obs_swstg_danger.svg";
  } else if (swinItem.swstgOvlvl === 30) {
    // 観測開始水位超過
    stageIcon = "/kawabou/img/obs_icons/obs_swstg_start.svg";
  }

  return stageIcon;
}

/**
 * 観測所アイコンの取得
 */
function getIcon(tm, item, isFldCtl) {
  // 水位観測所
  if (tm == 4) {
    return setStageIcon(item, isFldCtl);
  }
  // ダム観測所
  else if (tm == 7) {
    return setDamIcon(item);
  }
  // 河川カメラ
  else if (tm == 100) {
    return setCctvIcon();
  }
  // 雨量観測所
  else if (tm == 1) {
    return setRainIcon(item);
  }
  // 水質観測所
  else if (tm == 6) {
    return setWtrQualIcon(item);
  }
  // 海岸観測所
  else if (tm == 12) {
    return setCoastIcon(item);
  }
  // 積雪観測所
  else if (tm == 3) {
    return setSnowIcon(item);
  }
  // 簡易カメラ
  else if (tm == 200) {
    return setScamIcon();
  }
  // 危機管理水位観測所
  else if (tm == 300) {
    return setSwStageIcon(item);
  }
}

/**
 * リストが空かどうかの判定
 * @param {*} jsonData JSON
 */
function isEmpty(obsList) {
  if (obsList == null) {
    return true;
  } else if (Object.keys(obsList).length == 0) {
    return true;
  } else {
    return false;
  }
}

/** 表示フラグ判定
 * @param {*} obsInfo 観測所情報
 * @param selectObsDisp 観測所表示設定
 */
function checkExistFlg(obsInfo, selectObsDisp) {
  var existNm = 0;
  // 観測所表示設定がONになっている観測所詳細フラグを加算
  if (selectObsDisp.stgDisp && obsInfo.stgExistFlg > 0) {
    existNm += 1;
  }
  if (selectObsDisp.swstgDisp && obsInfo.swExistFlg > 0) {
    existNm += 1;
  }
  if (selectObsDisp.damDisp && obsInfo.damExistFlg > 0) {
    existNm += 1;
  }
  if (selectObsDisp.cctvDisp && obsInfo.scamExistFlg > 0) {
    // カメラの存在有無(CCTV/簡易カメラ)は簡易カメラ存在フラグを見て判断する
    existNm += 1;
  }
  if (selectObsDisp.rnDisp && obsInfo.rnExistFlg > 0) {
    existNm += 1;
  }
  if (selectObsDisp.qwtrDisp && obsInfo.qwtrExistFlg > 0) {
    existNm += 1;
  }
  if (selectObsDisp.coastDisp && obsInfo.coastExistFlg > 0) {
    existNm += 1;
  }
  if (selectObsDisp.snwDisp && obsInfo.snwExistFlg > 0) {
    existNm += 1;
  }
  return existNm;
}

/** 表示超過フラグ判定
 * @param {*} stgOvlvl 通常水位基準水位超過
 * @param {*} swStgOvlvl 危機管理水位基準水位超過
 * @param {*} selectObsDisp 観測所表示設定
 */
function checOvLvlFlg(stgOvlvl, swStgOvlvl, selectObsDisp) {
  var ovLvl = null;
  // 通常水位・危機管理水位のうち基準水位超過が高い方を出力する
  if (selectObsDisp.stgDisp && selectObsDisp.swstgDisp) {
    if (stgOvlvl > 0) {
      ovLvl = stgOvlvl;
    } else if (swStgOvlvl > 0) {
      ovLvl = swStgOvlvl;
    }
  } else if (selectObsDisp.stgDisp && !selectObsDisp.swstgDisp) {
    // 観測所表示設定で通常水位のみ表示する場合
    ovLvl = stgOvlvl;
  } else if (!selectObsDisp.stgDisp && selectObsDisp.swstgDisp) {
    // 観測所表示設定で危機管理水位のみ表示する場合
    ovLvl = swStgOvlvl;
  }
  // 氾濫注意水位超過以上を出力する
  return ovLvl != 0 && ovLvl != 10 ? ovLvl : null;
}
/** 超過水位観測所表示判定
 * @param {*} stgOvlvl 通常水位基準水位超過
 * @param {*} swStgOvlvl 危機管理水位基準水位超過
 * @param {*} selectObsDisp 観測所表示設定
 */
function checStgFlg(stgOvlvl, swStgOvlvl, selectObsDisp) {
  var ovLvl = null;
  var showStg = null;
  // 通常水位・危機管理水位のうち基準水位超過が高い方を出力する
  if (selectObsDisp.stgDisp && selectObsDisp.swstgDisp) {
    if (stgOvlvl > 0) {
      ovLvl = stgOvlvl;
      showStg = 1;
    } else if (swStgOvlvl > 0) {
      ovLvl = swStgOvlvl;
      showStg = 2;
    }
  } else if (selectObsDisp.stgDisp && !selectObsDisp.swstgDisp) {
    // 観測所表示設定で通常水位のみ表示する場合
    ovLvl = stgOvlvl;
    showStg = 1;
  } else if (!selectObsDisp.stgDisp && selectObsDisp.swstgDisp) {
    // 観測所表示設定で危機管理水位のみ表示する場合
    ovLvl = swStgOvlvl;
    showStg = 2;
  }
  // 氾濫注意水位超過以上を出力する
  return ovLvl != 0 && ovLvl != 10 ? showStg : null;
}
/**
 * 市町村別観測所情報をセットする
 *
 * @param twnCd 市町村コード
 * @param obsInfo 観測所情報
 */
function setDispTwnTmInfo(twnCd, obsInfo) {
  return {
    twnCd: twnCd,
    nmStg: obsInfo.Stg.nmList,
    nmDam: obsInfo.Dam.nmList,
    nmRain: obsInfo.Rain.nmList,
    nmSnow: obsInfo.Snow.nmList,
    nmCctv: obsInfo.Cctv.nmList,
    nmScam: obsInfo.Scam.nmList,
    nmTmQwtr: obsInfo.Qwtr.nmList,
    nmCoast: obsInfo.Coast.nmList,
    nmSwin: obsInfo.Swin.nmList,
    lgStg: obsInfo.Stg.lgList,
    lgDam: obsInfo.Dam.lgList,
    lgRain: obsInfo.Rain.lgList,
    lgSnow: obsInfo.Snow.lgList,
    lgCctv: obsInfo.Cctv.lgList,
    lgScam: obsInfo.Scam.lgList,
    lgTmQwtr: obsInfo.Qwtr.lgList,
    lgCoast: obsInfo.Coast.lgList,
    lgSwin: obsInfo.Swin.lgList,
  };
}

/**
 * 河川別観測所情報をセットする
 *
 * @param rvrCd 河川番号
 * @param obsInfo 観測所情報
 */
function setDispRvrTmInfo(rvrCd, obsInfo) {
  return {
    rvrCd: rvrCd,
    nmStg: obsInfo.Stg.nmList,
    nmDam: obsInfo.Dam.nmList,
    nmRain: obsInfo.Rain.nmList,
    nmSnow: obsInfo.Snow.nmList,
    nmCctv: obsInfo.Cctv.nmList,
    nmScam: obsInfo.Scam.nmList,
    nmTmQwtr: obsInfo.Qwtr.nmList,
    nmCoast: obsInfo.Coast.nmList,
    nmSwin: obsInfo.Swin.nmList,
    lgStg: obsInfo.Stg.lgList,
    lgDam: obsInfo.Dam.lgList,
    lgRain: obsInfo.Rain.lgList,
    lgSnow: obsInfo.Snow.lgList,
    lgCctv: obsInfo.Cctv.lgList,
    lgScam: obsInfo.Scam.lgList,
    lgTmQwtr: obsInfo.Qwtr.lgList,
    lgCoast: obsInfo.Coast.lgList,
    lgSwin: obsInfo.Swin.lgList,
  };
}

/**
 * 登録地点観測所一覧(危機管理以外)情報リポジトリパラメータをセットする(登録地点情報高アクセス対応)
 */
function setTmPointIndivParam(tmPointList) {
  let obsFcdParamList = [];
  for (var i = 0; i < tmPointList.length; i++) {
    var ofcCd = ("00000" + tmPointList[i].ofcCd).slice(-5);
    var itmkndCd = ("000" + tmPointList[i].itmkndCd).slice(-3);
    var obsCd = ("00000" + tmPointList[i].obsCd).slice(-5);
    var obsFcd = ofcCd + itmkndCd + obsCd;
    var obsKnd = setItmkndPath(itmkndCd);
    var obsParam = {
      obsFcd: obsFcd,
      obsKnd: obsKnd,
    };
    obsFcdParamList.push(obsParam);
  }
  return obsFcdParamList;
}
/**
 * 登録地点観測所一覧(危機管理)情報リポジトリパラメータをセットする(登録地点情報高アクセス対応)
 */
function setTmSwPointIndivParam(swPointList) {
  let swobsParamList = [];
  for (var i = 0; i < swPointList.length; i++) {
    var swobsCd = swPointList[i].swobsCd;
    var obsParam = {
      obsFcd: swobsCd,
      obsKnd: "swstg",
    };
    swobsParamList.push(obsParam);
  }
  return swobsParamList;
}
/**
 * 観測所種別によるパスの設定(登録地点情報高アクセス対応)
 */
function setItmkndPath(itmkndCd) {
  if (itmkndCd === "004") {
    return "stg";
  } else if (itmkndCd === "007") {
    return "dam";
  } else if (itmkndCd === "001") {
    return "rn";
  } else if (itmkndCd === "006") {
    return "qwtr";
  } else if (itmkndCd === "012") {
    return "coast";
  } else if (itmkndCd === "003") {
    return "snw";
  }
}
/**
 * 指定日時(日付)によるパスの設定(登録地点情報高アクセス対応)
 */

function setObsDate(time) {
  return time.substring(0, 4) + time.substring(5, 7) + time.substring(8, 10);
}
/**
 * 指定日時(時間)によるパスの設定(登録地点情報高アクセス対応)
 */
function setObsTime(time) {
  return time.substring(11, 13) + time.substring(14, 16);
}

/**
 * 登録地点観測所一覧(危機管理以外)情報リポジトリパラメータをセットする(登録地点情報高アクセス対応)
 */
function setTmPointIndivData(obsInfo, obsValue, appTime) {
  var obsData = null;
  if (obsInfo.itmkndCd === 4 && obsValue !== null) {
    obsData = {
      ofcCd: obsInfo.ofcCd,
      itmkndCd: obsInfo.itmkndCd,
      obsCd: obsInfo.obsCd,
      obsNm: obsInfo.obsNm,
      obsTime: obsValue.obsTime,
      stg: obsValue.stg,
      stgHght: obsValue.stgHght,
      stgCcd: obsValue.stgCcd,
      stgQmflg: obsValue.stgQmflg,
      stgOvlvl: obsValue.stgOvlvl,
      stgLtstChg: obsValue.stgLtstChg,
      stg10mChg: obsValue.stg10mChg,
      stg10mChgCcd: obsValue.stg10mChgCcd,
      rsrvStg: obsInfo.rsrvStg,
      warnStg: obsInfo.warnStg,
      spclWarnStg: obsInfo.spclWarnStg,
      dngStg: obsInfo.dngStg,
      fldStg: obsInfo.fldStg,
      dspFlg: obsInfo.dspFlg,
      fldfrFlg: obsInfo.fldfrFlg,
      evstgFlg: obsInfo.evstgFlg,
      fldctlFlg: obsInfo.fldctlFlg,
    };
  } else if (obsInfo.itmkndCd === 4 && obsValue === null) {
    obsData = {
      ofcCd: obsInfo.ofcCd,
      itmkndCd: obsInfo.itmkndCd,
      obsCd: obsInfo.obsCd,
      obsNm: obsInfo.obsNm,
      obsTime: appTime,
      stg: null,
      stgHght: null,
      stgCcd: 160,
      stgQmflg: null,
      stgOvlvl: null,
      stgLtstChg: null,
      stg10mChg: null,
      stg10mChgCcd: 160,
      rsrvStg: obsInfo.rsrvStg,
      warnStg: obsInfo.warnStg,
      spclWarnStg: obsInfo.spclWarnStg,
      dngStg: obsInfo.dngStg,
      fldStg: obsInfo.fldStg,
      fldfrFlg: obsInfo.fldfrFlg,
      evstgFlg: obsInfo.evstgFlg,
      fldctlFlg: obsInfo.fldctlFlg,
    };
  } else if (obsInfo.itmkndCd === 7 && obsValue !== null) {
    obsData = {
      ofcCd: obsInfo.ofcCd,
      itmkndCd: obsInfo.itmkndCd,
      obsCd: obsInfo.obsCd,
      obsNm: obsInfo.obsNm,
      obsTime: obsValue.obsTime,
      storLvl: obsValue.storLvl,
      storLvlCcd: obsValue.storLvlCcd,
      storPcntEff: obsValue.storPcntEff,
      storPcntEffCcd: obsValue.storPcntEffCcd,
      damdschLvl: obsValue.damdschLvl,
      storCapCcd: obsValue.storCapCcd,
      storPcntIrrCcd: obsValue.storPcntIrrCcd,
      storFcntIrrCcd: obsValue.storFcntIrrCcd,
      allSinkCcd: obsValue.allSinkCcd,
      allDischCcd: obsValue.allDischCcd,
      rwNoticeMng: obsInfo.rwNoticeMng,
    };
  } else if (obsInfo.itmkndCd === 7 && obsValue === null) {
    obsData = {
      ofcCd: obsInfo.ofcCd,
      itmkndCd: obsInfo.itmkndCd,
      obsCd: obsInfo.obsCd,
      obsNm: obsInfo.obsNm,
      obsTime: appTime,
      storLvl: null,
      storLvlCcd: 160,
      storPcntEff: null,
      storPcntEffCcd: 160,
      damdschLvl: null,
      storCapCcd: 160,
      storPcntIrrCcd: 160,
      storFcntIrrCcd: 160,
      allSinkCcd: 160,
      allDischCcd: 160,
      rwNoticeMng: obsInfo.rwNoticeMng,
    };
  } else if (obsInfo.itmkndCd === 1 && obsValue !== null) {
    obsData = {
      ofcCd: obsInfo.ofcCd,
      itmkndCd: obsInfo.itmkndCd,
      obsCd: obsInfo.obsCd,
      obsNm: obsInfo.obsNm,
      obsTime: obsValue.obsTime,
      rn10m: obsValue.rn10m,
      rn10mCcd: obsValue.rn10mCcd,
      rnInc: obsValue.rnInc,
      rnIncCcd: obsValue.rnIncCcd,
      rnHr10mCcd: obsValue.rnHr10mCcd,
      rn60mCcd: obsValue.rn60mCcd,
    };
  } else if (obsInfo.itmkndCd === 1 && obsValue === null) {
    obsData = {
      ofcCd: obsInfo.ofcCd,
      itmkndCd: obsInfo.itmkndCd,
      obsCd: obsInfo.obsCd,
      obsNm: obsInfo.obsNm,
      obsTime: appTime,
      rn10m: null,
      rn10mCcd: 160,
      rnInc: null,
      rnIncCcd: 160,
      rnHr10mCcd: 160,
      rn60mCcd: 160,
    };
  } else if (obsInfo.itmkndCd === 6 && obsValue !== null) {
    obsData = {
      ofcCd: obsInfo.ofcCd,
      itmkndCd: obsInfo.itmkndCd,
      obsCd: obsInfo.obsCd,
      obsNm: obsInfo.obsNm,
      obsTime: obsValue.obsTime,
      wtrtmp: obsValue.wtrtmp,
      wtrtmpCcd: obsValue.wtrtmpCcd,
      wtrtmpOvcd: obsValue.wtrtmpOvcd,
      turbdty: obsValue.turbdty,
      turbdtyCcd: obsValue.turbdtyCcd,
      turbdtyOvcd: obsValue.turbdtyOvcd,
      conductCcd: obsValue.conductCcd,
      conductOvcd: obsValue.conductOvcd,
      doxCcd: obsValue.doxCcd,
      doxOvcd: obsValue.doxOvcd,
      phCcd: obsValue.phCcd,
      phOvcd: obsValue.phOvcd,
      codCcd: obsValue.codCcd,
      codOvcd: obsValue.codOvcd,
      amnCcd: obsValue.amnCcd,
      amnOvcd: obsValue.amnOvcd,
      sltCcd: obsValue.sltCcd,
      sltOvcd: obsValue.sltOvcd,
      tyclsCd: obsInfo.tyclsCd,
      tysct1Cd: obsInfo.tysct1Cd,
    };
  } else if (obsInfo.itmkndCd === 6 && obsValue === null) {
    obsData = {
      ofcCd: obsInfo.ofcCd,
      itmkndCd: obsInfo.itmkndCd,
      obsCd: obsInfo.obsCd,
      obsNm: obsInfo.obsNm,
      obsTime: appTime,
      wtrtmp: null,
      wtrtmpCcd: 160,
      wtrtmpOvcd: null,
      turbdty: null,
      turbdtyCcd: 160,
      turbdtyOvcd: null,
      conductCcd: 160,
      conductOvcd: null,
      doxCcd: 160,
      doxOvcd: null,
      phCcd: 160,
      phOvcd: null,
      codCcd: 160,
      codOvcd: null,
      amnCcd: 160,
      amnOvcd: null,
      sltCcd: 160,
      sltOvcd: null,
      tyclsCd: obsInfo.tyclsCd,
      tysct1Cd: obsInfo.tysct1Cd,
    };
  } else if (obsInfo.itmkndCd === 12 && obsValue !== null) {
    obsData = {
      ofcCd: obsInfo.ofcCd,
      itmkndCd: obsInfo.itmkndCd,
      obsCd: obsInfo.obsCd,
      obsNm: obsInfo.obsNm,
      obsTime: obsValue.obsTime,
      maxwvHght: obsValue.maxwvHght,
      maxwvHghtCcd: obsValue.maxwvHghtCcd,
      maxwvCyclCcd: obsValue.maxwvCyclCcd,
      onthwvHghtCcd: obsValue.onthwvHghtCcd,
      onthwvHghtCautOvflg: obsValue.onthwvHghtCautOvflg,
      onthwvHghtWarnOvflg: obsValue.onthwvHghtWarnOvflg,
      onthwvCyclCcd: obsValue.onthwvCyclCcd,
      tidlvl: obsValue.tidlvl,
      tidlvlCcd: obsValue.tidlvlCcd,
      tidlvlCautOvflg: obsValue.tidlvlCautOvflg,
      tidlvlWarnOvflg: obsValue.tidlvlWarnOvflg,
      avewndSpdCcd: obsValue.avewndSpdCcd,
      avewndSpdCautOvflg: obsValue.avewndSpdCautOvflg,
      avewndSpdWarnOvflg: obsValue.avewndSpdWarnOvflg,
      avewndDirCcd: obsValue.avewndDirCcd,
      wvHghtCaut: obsInfo.wvHghtCaut,
      wvHghtWarn: obsInfo.wvHghtWarn,
      tidlvlCaut: obsInfo.tidlvlCaut,
      tidlvlWarn: obsInfo.tidlvlWarn,
      wndSpdCaut: obsInfo.wndSpdCaut,
      wndSpdWarn: obsInfo.wndSpdWarn,
    };
  } else if (obsInfo.itmkndCd === 12 && obsValue === null) {
    obsData = {
      ofcCd: obsInfo.ofcCd,
      itmkndCd: obsInfo.itmkndCd,
      obsCd: obsInfo.obsCd,
      obsNm: obsInfo.obsNm,
      obsTime: appTime,
      maxwvHght: null,
      maxwvHghtCcd: 160,
      maxwvCyclCcd: 160,
      onthwvHghtCcd: 160,
      onthwvHghtCautOvflg: null,
      onthwvHghtWarnOvflg: null,
      onthwvCyclCcd: 160,
      tidlvl: null,
      tidlvlCcd: 160,
      tidlvlCautOvflg: null,
      tidlvlWarnOvflg: null,
      avewndSpdCcd: 160,
      avewndSpdCautOvflg: null,
      avewndSpdWarnOvflg: null,
      avewndDirCcd: 160,
      wvHghtCaut: obsInfo.wvHghtCaut,
      wvHghtWarn: obsInfo.wvHghtWarn,
      tidlvlCaut: obsInfo.tidlvlCaut,
      tidlvlWarn: obsInfo.tidlvlWarn,
      wndSpdCaut: obsInfo.wndSpdCaut,
      wndSpdWarn: obsInfo.wndSpdWarn,
    };
  } else if (obsInfo.itmkndCd === 3 && obsValue !== null) {
    obsData = {
      ofcCd: obsInfo.ofcCd,
      itmkndCd: obsInfo.itmkndCd,
      obsCd: obsInfo.obsCd,
      obsNm: obsInfo.obsNm,
      obsTime: obsValue.obsTime,
      snwdp: obsValue.snwdp,
      snwdpCcd: obsValue.snwdpCcd,
      tmp: obsValue.tmp,
      tmpCcd: obsValue.tmpCcd,
    };
  } else if (obsInfo.itmkndCd === 3 && obsValue === null) {
    obsData = {
      ofcCd: obsInfo.ofcCd,
      itmkndCd: obsInfo.itmkndCd,
      obsCd: obsInfo.obsCd,
      obsNm: obsInfo.obsNm,
      obsTime: appTime,
      snwdp: null,
      snwdpCcd: 160,
      tmp: null,
      tmpCcd: 160,
    };
  }
  return obsData;
}

/**
 * 登録地点観測所一覧(危機管理)情報リポジトリパラメータをセットする(登録地点情報高アクセス対応)
 */
function setSwTmPointIndivData(swobsInfo, swobsValue, appTime) {
  var swobsData = null;
  if (swobsValue !== null) {
    swobsData = {
      swofcCd: swobsInfo.swofcCd,
      itmkndCd: 300,
      swobsCd: swobsInfo.swobsCd,
      swobsNm: swobsInfo.swobsNm,
      obsTime: swobsValue.obsTime,
      stg: swobsValue.stgHght,
      stgQmFlg: swobsValue.stgQmFlg,
      swstgOvlvl: swobsValue.swstgOvlvl,
      swstgCcd: 0,
      strtStg: swobsInfo.strtStg,
      dngStg: swobsInfo.dngStg,
      fldStg: swobsInfo.fldStg,
    };
  } else {
    swobsData = {
      swofcCd: swobsInfo.swofcCd,
      itmkndCd: 300,
      swobsCd: swobsInfo.swobsCd,
      swobsNm: swobsInfo.swobsNm,
      obsTime: appTime,
      stg: null,
      stgQmflg: null,
      swstgOvlvl: null,
      swstgCcd: 160,
      strtStg: swobsInfo.strtStg,
      dngStg: swobsInfo.dngStg,
      fldStg: swobsInfo.fldStg,
    };
  }
  return swobsData;
}

/**
 * [登録地点]観測所種別リストを作成(登録地点情報高アクセス対応)
 * @param {*} obsDataList 観測所情報リスト
 */
function convertIndivDataList(obsDataList) {
  let tmPointStageList = [];
  let tmPointDamList = [];
  let tmPointRainList = [];
  let tmPointSnowList = [];
  let tmPointQwtrList = [];
  let tmPointCoastList = [];
  let tmPointswStageList = [];
  for (var obsData of obsDataList) {
    if (obsData.itmkndCd === 4) {
      tmPointStageList.push(obsData);
    } else if (obsData.itmkndCd === 7) {
      tmPointDamList.push(obsData);
    } else if (obsData.itmkndCd === 1) {
      tmPointRainList.push(obsData);
    } else if (obsData.itmkndCd === 6) {
      tmPointQwtrList.push(obsData);
    } else if (obsData.itmkndCd === 12) {
      tmPointCoastList.push(obsData);
    } else if (obsData.itmkndCd === 3) {
      tmPointSnowList.push(obsData);
    } else if (obsData.itmkndCd === 300) {
      tmPointswStageList.push(obsData);
    }
  }

  return {
    tmPointStageList: tmPointStageList,
    tmPointDamList: tmPointDamList,
    tmPointRainList: tmPointRainList,
    tmPointSnowList: tmPointSnowList,
    tmPointQwtrList: tmPointQwtrList,
    tmPointCoastList: tmPointCoastList,
    tmPointswStageList: tmPointswStageList,
  };
}

/**
 * 通常水位：超過基準水位名の取得
 */
function getStgOvlvlNm(stgOvlvl) {
  if (stgOvlvl === 90) {
    return "氾濫開始水位超過";
  } else if (stgOvlvl === 80 || stgOvlvl === 70) {
    return "氾濫危険水位超過";
  } else if (stgOvlvl === 60 || stgOvlvl === 50) {
    return "避難判断水位超過";
  } else if (stgOvlvl === 40 || stgOvlvl === 30 || stgOvlvl === 20) {
    return "氾濫注意水位超過";
  }
  return "";
}

/**
 * 通常水位：短縮超過基準水位名の取得
 */
function getShortStgOvlvlNm(stgOvlvl) {
  if (stgOvlvl === 90) {
    return "氾濫開始";
  } else if (stgOvlvl === 80 || stgOvlvl === 70) {
    return "氾濫危険";
  } else if (stgOvlvl === 60 || stgOvlvl === 50) {
    return "避難判断";
  } else if (stgOvlvl === 40 || stgOvlvl === 30 || stgOvlvl === 20) {
    return "氾濫注意";
  }
  return "";
}

/**
 * 危機管理水位：超過基準水位名の取得
 */
function getSwStgOvlvlNm(stgOvlvl) {
  if (stgOvlvl === 90) {
    return "氾濫開始水位超過";
  } else if (stgOvlvl === 80) {
    return "危険水位超過";
  } else if (stgOvlvl === 30) {
    return "水位観測中";
  }
  return "";
}

/**
 * 危機管理水位：短縮超過基準水位名の取得
 */
function getShortSwStgOvlvlNm(stgOvlvl) {
  if (stgOvlvl === 90) {
    return "氾濫開始";
  } else if (stgOvlvl === 80) {
    return "危険水位";
  } else if (stgOvlvl === 30) {
    return "観測開始";
  }
  return "";
}

/**
 * 未収集判定
 * @param itmkndCd 観測所種別コード
 * @param {*} obsItem 観測所情報
 */
function checkNotCollected(itmkndCd, obsItem) {
  if (itmkndCd === 4) {
    if (
      typeof obsItem.stgCcd !== "undefined" &&
      obsItem.stgCcd === NOT_COLLECTED
    ) {
      return true;
    }
    return false;
  } else if (itmkndCd === 7) {
    if (
      typeof obsItem.storLvlCcd !== "undefined" &&
      obsItem.storLvlCcd === NOT_COLLECTED &&
      typeof obsItem.storCapCcd !== "undefined" &&
      obsItem.storCapCcd === NOT_COLLECTED &&
      typeof obsItem.storPcntIrrCcd !== "undefined" &&
      obsItem.storPcntIrrCcd === NOT_COLLECTED &&
      typeof obsItem.allSinkCcd !== "undefined" &&
      obsItem.allSinkCcd === NOT_COLLECTED &&
      typeof obsItem.allDischCcd !== "undefined" &&
      obsItem.allDischCcd === NOT_COLLECTED &&
      typeof obsItem.storPcntEffCcd !== "undefined" &&
      obsItem.storPcntEffCcd === NOT_COLLECTED
    ) {
      return true;
    }
    return false;
  } else if (itmkndCd === 1) {
    if (
      typeof obsItem.rn10mCcd !== "undefined" &&
      obsItem.rn10mCcd === NOT_COLLECTED &&
      typeof obsItem.rnHr10mCcd !== "undefined" &&
      obsItem.rnHr10mCcd === NOT_COLLECTED &&
      typeof obsItem.rnIncCcd !== "undefined" &&
      obsItem.rnIncCcd === NOT_COLLECTED &&
      typeof obsItem.rn60mCcd !== "undefined" &&
      obsItem.rn60mCcd === NOT_COLLECTED
    ) {
      return true;
    }
    return false;
  } else if (itmkndCd === 6) {
    if (
      typeof obsItem.wtrtmpCcd !== "undefined" &&
      obsItem.wtrtmpCcd === NOT_COLLECTED &&
      typeof obsItem.conductCcd !== "undefined" &&
      obsItem.conductCcd === NOT_COLLECTED &&
      typeof obsItem.doxCcd !== "undefined" &&
      obsItem.doxCcd === NOT_COLLECTED &&
      typeof obsItem.phCcd !== "undefined" &&
      obsItem.phCcd === NOT_COLLECTED &&
      typeof obsItem.turbdtyCcd !== "undefined" &&
      obsItem.turbdtyCcd === NOT_COLLECTED &&
      typeof obsItem.codCcd !== "undefined" &&
      obsItem.codCcd === NOT_COLLECTED &&
      typeof obsItem.amnCcd !== "undefined" &&
      obsItem.amnCcd === NOT_COLLECTED &&
      typeof obsItem.sltCcd !== "undefined" &&
      obsItem.sltCcd === NOT_COLLECTED
    ) {
      return true;
    }
    return false;
  } else if (itmkndCd === 12) {
    if (
      typeof obsItem.onthwvHghtCcd !== "undefined" &&
      obsItem.onthwvHghtCcd === NOT_COLLECTED &&
      typeof obsItem.tidlvlCcd !== "undefined" &&
      obsItem.tidlvlCcd === NOT_COLLECTED &&
      typeof obsItem.avewndSpdCcd !== "undefined" &&
      obsItem.avewndSpdCcd === NOT_COLLECTED
    ) {
      return true;
    }
    return false;
  } else if (itmkndCd === 3) {
    if (
      typeof obsItem.snwdpCcd !== "undefined" &&
      obsItem.snwdpCcd === NOT_COLLECTED
    ) {
      return true;
    }
    return false;
  } else if (itmkndCd === 300) {
    if (
      typeof obsItem.swstgCcd !== "undefined" &&
      obsItem.swstgCcd === NOT_COLLECTED
    ) {
      return true;
    }
    return false;
  }
  return false;
}

/**
 * 風向 名称変換
 * @param {*} wnd 平均風向(コード)
 */
function formatWndDir(wnd) {
  if (wnd === 0) return "無風";
  else if (wnd === 1) return "NNE";
  else if (wnd === 2) return "NE";
  else if (wnd === 3) return "ENE";
  else if (wnd === 4) return "E";
  else if (wnd === 5) return "ESE";
  else if (wnd === 6) return "SE";
  else if (wnd === 7) return "SSE";
  else if (wnd === 8) return "S";
  else if (wnd === 9) return "SSW";
  else if (wnd === 10) return "SW";
  else if (wnd === 11) return "WSW";
  else if (wnd === 12) return "W";
  else if (wnd === 13) return "WNW";
  else if (wnd === 14) return "NW";
  else if (wnd === 15) return "NNW";
  else if (wnd === 16) return "N";
  else return wnd; // 1 - 16 に該当しない場合、そのまま返す。'欠測' や '閉局'、'--' など。
}
